import { 
    Mod,
    ModDatabase, 
    ContentType, 
    IdolSize 
  } from '../types/mods';

  export const mods: Record<string, Mod> = {
    'prefix_abyss_your_maps_have_1525_minor': {
      id: 1,
      tradeId: 'explicit.stat_4278144676',
      description: 'Your Maps have +(15–25)% chance to contain an Abyss',
      range: [15, 25],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_abyss_your_maps_have_80100_minor': {
      id: 2,
      tradeId: 'explicit.stat_4111037980',
      description: 'Your Maps have (80–100)% increased chance to contain an Abyss',
      range: [80, 100],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_1525_minor': {
      id: 3,
      tradeId: 'explicit.stat_2709296039',
      description: 'Your Maps have +(15–25)% chance to contain Alva',
      range: [15, 25],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_80100_minor': {
      id: 4,
      tradeId: 'explicit.stat_3629418990',
      description: 'Your Maps have (80–100)% increased chance to contain Alva',
      range: [80, 100],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_a_minor': {
      id: 5,
      tradeId: 'explicit.stat_1123357133',
      description: 'Your Maps have a (15–25)% chance to contain an additional Rogue Exile',
      range: [15, 25],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_710_minor': {
      id: 6,
      tradeId: 'explicit.stat_2974922599',
      description: 'Your Maps have +(7–10)% chance to contain a Rogue Exile',
      range: [7, 10],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_rogue_exiles_map_bosses_have_610_minor': {
      id: 7,
      tradeId: 'explicit.stat_472880157',
      description: 'Map Bosses have (6–10)% chance to be accompanied by two Rogue Exile Bodyguards',
      range: [6, 10],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_rogue_exiles_map_bosses_have_23_minor': {
      id: 8,
      tradeId: 'explicit.stat_3408085256',
      description: 'Map Bosses have (2–3)% chance to be accompanied by two Rogue Exiles',
      range: [2, 3],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_1525_minor': {
      id: 9,
      tradeId: 'explicit.stat_1566972708',
      description: 'Your Maps have +(15–25)% chance to contain Einhar',
      range: [15, 25],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_80100_minor': {
      id: 10,
      tradeId: 'explicit.stat_1301096166',
      description: 'Your Maps have (80–100)% increased chance to contain Einhar',
      range: [80, 100],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_beyond_1525_chance_for_your_minor': {
      id: 11,
      tradeId: 'explicit.stat_3438840900',
      description: '(15–25)% chance for your Maps to attract Beyond Demons',
      range: [15, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_1525_minor': {
      id: 12,
      tradeId: 'explicit.stat_764545335',
      description: 'Your Maps have +(15–25)% chance to contain a Blight Encounter',
      range: [15, 25],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_80100_minor': {
      id: 13,
      tradeId: 'explicit.stat_1393318927',
      description: 'Your Maps have (80–100)% increased chance to contain a Blight Encounter',
      range: [80, 100],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_1525_minor': {
      id: 14,
      tradeId: 'explicit.stat_1133841298',
      description: 'Your Maps have +(15–25)% chance to contain Breaches',
      range: [15, 25],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_80100_minor': {
      id: 15,
      tradeId: 'explicit.stat_2372432713',
      description: 'Your Maps have (80–100)% increased chance to contain a Breach',
      range: [80, 100],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_breach_your_maps_which_contain_minor': {
      id: 16,
      tradeId: 'explicit.stat_3049505189',
      description: 'Your Maps which contain Breaches have (15–25)% chance to contain an additional Breach',
      range: [15, 25],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_1525_minor': {
      id: 17,
      tradeId: 'explicit.stat_1808954678',
      description: 'Your Maps have +(15–25)% chance to contain a Mirror of Delirium',
      range: [15, 25],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_80100_minor': {
      id: 18,
      tradeId: 'explicit.stat_3573600538',
      description: 'Your Maps have (80–100)% increased chance to contain a Mirror of Delirium',
      range: [80, 100],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_1525_minor': {
      id: 19,
      tradeId: 'explicit.stat_4267923742',
      description: 'Your Maps have +(15–25)% chance to contain Niko',
      range: [15, 25],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_80100_minor': {
      id: 20,
      tradeId: 'explicit.stat_399319107',
      description: 'Your Maps have (80–100)% increased chance to contain Niko',
      range: [80, 100],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_delve_your_white_tier_maps_minor': {
      id: 21,
      tradeId: 'explicit.stat_1235418654',
      description: 'Your White Tier Maps grant (100–150) additional Voltaxic Sulphite on Completion',
      range: [100, 150],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_delve_your_yellow_tier_maps_minor': {
      id: 22,
      tradeId: 'explicit.stat_932764321',
      description: 'Your Yellow Tier Maps grant (150–200) additional Voltaxic Sulphite on Completion',
      range: [100, 150],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_delve_your_red_tier_maps_minor': {
      id: 23,
      tradeId: 'explicit.stat_1267068028',
      description: 'Your Red Tier Maps grant (200–250) additional Voltaxic Sulphite on Completion',
      range: [200, 250],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_710_minor': {
      id: 24,
      tradeId: 'explicit.stat_2571125745',
      description: 'Your Maps have +(7–10)% chance to contain a Shrine',
      range: [7, 10],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_a_minor': {
      id: 25,
      tradeId: 'explicit.stat_1260233365',
      description: 'Your Maps have a (35–50)% chance to contain an additional Shrine',
      range: [35, 50],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_710_minor': {
      id: 26,
      tradeId: 'explicit.stat_4098286334',
      description: 'Your Maps have +(7–10)% chance to contain an Imprisoned Monster',
      range: [7, 10],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_3550_minor': {
      id: 27,
      tradeId: 'explicit.stat_2039130613',
      description: 'Your Maps have (35–50)% chance to contain an additional Imprisoned Monster',
      range: [35, 50],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_1525_minor': {
      id: 28,
      tradeId: 'explicit.stat_4154778375',
      description: 'Your Maps have +(15–25)% chance to contain an Expedition Encounter',
      range: [15, 25],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_80100_minor': {
      id: 29,
      tradeId: 'explicit.stat_1561678231',
      description: 'Your Maps have (80–100)% increased chance to contain an Expedition Encounter',
      range: [80, 100],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_have_a_minor': {
      id: 30,
      tradeId: 'explicit.stat_266448395',
      description: 'Your Maps have a (35–50)% chance to contain an additional Harbinger',
      range: [35, 50],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_1525_minor': {
      id: 31,
      tradeId: 'explicit.stat_1145451936',
      description: 'Your Maps have +(15–25)% chance to contain The Sacred Grove',
      range: [15, 25],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_80100_minor': {
      id: 32,
      tradeId: 'explicit.stat_2936740844',
      description: 'Your Maps have (80–100)% increased chance to contain The Sacred Grove',
      range: [80, 100],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_1525_minor': {
      id: 33,
      description: 'Your Maps have +(15–25)% chance to contain a Smuggler\'s Cache',
      tradeId: 'explicit.stat_1975869602',
      range: [15, 25],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_80100_minor': {
      id: 34,
      tradeId: 'explicit.stat_4069523014',
      description: 'Your Maps have (80–100)% increased chance to contain a Smuggler\'s Cache',
      range: [80, 100],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_heist_1015_increased_heist_contracts_minor': {
      id: 35,
      tradeId: 'explicit.stat_3022689249',
      description: '(10–15)% increased Heist Contracts found in your Maps',
      range: [10, 15],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_1525_minor': {
      id: 36,
      tradeId: 'explicit.stat_527292219',
      description: 'Your Maps have +(15–25)% chance to contain Jun',
      range: [15, 25],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_80100_minor': {
      id: 37,
      tradeId: 'explicit.stat_4116217552',
      description: 'Your Maps have (80–100)% increased chance to contain Jun',
      range: [80, 100],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_1525_minor': {
      id: 38,
      tradeId: 'explicit.stat_1981273563',
      description: 'Your Maps have +(15–25)% chance to contain a Legion Encounter',
      range: [15, 25],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_80100_minor': {
      id: 39,
      tradeId: 'explicit.stat_310950600',
      description: 'Your Maps have (80–100)% increased chance to contain a Legion Encounter',
      range: [80, 100],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_80100_minor': {
      id: 40,
      tradeId: 'explicit.stat_880963174',
      description: 'Your Maps have (80–100)% increased chance to contain an Ultimatum Encounter',
      range: [80, 100],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_1525_minor': {
      id: 41,
      tradeId: 'explicit.stat_1365687125',
      description: 'Your Maps have +(15–25)% chance to contain an Ultimatum Encounter',
      range: [15, 25],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_1525_minor': {
      id: 42,
      tradeId: 'explicit.stat_1314822783',
      description: 'Your Maps have +(15–25)% chance to contain Ritual Altars',
      range: [15, 25],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_80100_minor': {
      id: 43,
      tradeId: 'explicit.stat_1777351949',
      description: 'Your Maps have (80–100)% increased chance to contain Ritual Altars',
      range: [80, 100],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_have_3550_minor': {
      id: 44,
      tradeId: 'explicit.stat_2388936716',
      description: 'Your Maps have +(35–50)% chance to contain a Strongbox',
      range: [35, 50],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_a_minor': {
      id: 45,
      tradeId: 'explicit.stat_846433713',
      description: 'Your Maps have a (35–50)% chance to be haunted by an additional Tormented Spirit',
      range: [35, 50],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_710_minor': {
      id: 46,
      tradeId: 'explicit.stat_2750973094',
      description: 'Your Maps have +(7–10)% chance to be haunted by a Tormented Spirit',
      range: [7, 10],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_scarabs_510_increased_scarabs_found_minor': {
      id: 47,
      tradeId: 'explicit.stat_1351268685',
      description: '(5–10)% increased Scarabs found in your Maps',
      range: [5, 10],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_maps_1015_increased_atlas_scouting_minor': {
      id: 48,
      tradeId: 'explicit.stat_602879359',
      description: '(10–15)% increased Atlas Scouting Reports found in your Maps',
      range: [10, 15],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_maps_23_increased_maps_found_minor': {
      id: 49,
      tradeId: 'explicit.stat_2777224821',
      description: '(2–3)% increased Maps found in Area',
      range: [2, 3],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_maps_your_maps_contain_35_minor': {
      id: 50,
      tradeId: 'explicit.stat_1366180761',
      description: 'Your Maps contain (3–5)% more Monster Packs consisting of difficult and rewarding Monsters',
      range: [3, 5],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_maps_tier_115_maps_found_minor': {
      id: 51,
      tradeId: 'explicit.stat_51196661',
      description: 'Tier 1–15 Maps found have (5–10)% chance to become 1 tier higher',
      range: [5, 10],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'prefix_conquerors_map_bosses_have_4060_minor': {
      id: 52,
      tradeId: 'explicit.stat_1554844434',
      description: 'Map Bosses have (40–60)% increased chance to drop a Conqueror Map',
      range: [40, 60],
      contentType: ContentType.CONQUERORS,
      idolSizes: [IdolSize.MINOR],
      type: 'prefix'
    },
    'suffix_abyss_abyssal_troves_and_stygian_minor': {
      id: 53,
      tradeId: 'explicit.stat_1553039081',
      description: 'Abyssal Troves and Stygian Spires in your Maps have (15–25)% increased chance to contain or drop an Abyss Jewel',
      range: [15, 25],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_abyss_abyssal_troves_and_stygian_minor_54': {
      id: 54,
      tradeId: 'explicit.stat_2609011894',
      description: 'Abyssal Troves and Stygian Spires in your Maps have (6–10)% chance to drop a Rare Item with an Abyssal Socket',
      range: [6, 10],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_abyss_300350_increased_rarity_of_minor': {
      id: 55,
      tradeId: 'explicit.stat_2786105132',
      description: '(300–350)% increased Rarity of Items Dropped by Abyssal Troves and Stygian Spires in your Maps',
      range: [300, 350],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_incursion_incursions_in_your_maps_minor': {
      id: 56,
      tradeId: 'explicit.stat_2490898366',
      description: 'Incursions in your Maps have (4–6)% increased Pack Size',
      range: [4, 6],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_bestiary_510_chance_to_create_minor': {
      id: 57,
      tradeId: 'explicit.stat_2836003955',
      description: '(5–10)% chance to create a copy of Beasts Captured in your Maps',
      range: [5, 10],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_bestiary_red_beasts_in_your_minor': {
      id: 58,
      tradeId: 'explicit.stat_59091266',
      description: 'Red Beasts in your Maps have (40–60)% increased chance to be from The Deep',
      range: [40, 60],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_bestiary_red_beasts_in_your_minor_59': {
      id: 59,
      tradeId: 'explicit.stat_3090817208',
      description: 'Red Beasts in your Maps have (40–60)% increased chance to be from The Wilds',
      range: [40, 60],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_bestiary_red_beasts_in_your_minor_60': {
      id: 60,
      tradeId: 'explicit.stat_1595637549',
      description: 'Red Beasts in your Maps have (40–60)% increased chance to be from The Caverns',
      range: [40, 60],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_bestiary_red_beasts_in_your_minor_61': {
      id: 61,
      tradeId: 'explicit.stat_2436491720',
      description: 'Red Beasts in your Maps have (40–60)% increased chance to be from The Sands',
      range: [40, 60],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_beyond_beyond_demons_in_your_minor': {
      id: 62,
      tradeId: 'explicit.stat_3175325766',
      description: 'Beyond Demons in your Maps have (35–45)% increased chance to be followers of K\'tash',
      range: [35, 45],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_beyond_beyond_demons_in_your_minor_63': {
      id: 63,
      tradeId: 'explicit.stat_3857813970',
      description: 'Beyond Demons in your Maps have (35–45)% increased chance to be followers of Beidat',
      range: [35, 45],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_beyond_beyond_demons_in_your_minor_64': {
      id: 64,
      tradeId: 'explicit.stat_2541655454',
      description: 'Beyond Demons in your Maps have (35–45)% increased chance to be followers of Ghorr',
      range: [35, 45],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_blight_1520_reduced_cost_of_minor': {
      id: 65,
      tradeId: 'explicit.stat_2078691497',
      description: '(15–20)% reduced Cost of Building and Upgrading Towers',
      range: [15, 20],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_blight_blight_chests_in_your_minor': {
      id: 66,
      tradeId: 'explicit.stat_2002028881',
      description: 'Blight Chests in your Maps have (15–25)% more chance to contain Blighted Maps',
      range: [15, 25],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_minor': {
      id: 67,
      tradeId: 'explicit.stat_1090596078',
      description: 'Breaches in your Maps spawn (15–20)% increased Magic Monsters',
      range: [15, 20],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_breach_chayula_who_dreamt_in_minor': {
      id: 68,
      tradeId: 'explicit.stat_3374535912',
      description: 'Chayula, Who Dreamt in your Maps has a (20–30)% chance to be Duplicated',
      range: [20, 30],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_breach_esh_forked_thought_in_minor': {
      id: 69,
      tradeId: 'explicit.stat_1539916749',
      description: 'Esh, Forked Thought in your Maps has a (20–30)% chance to be Duplicated',
      range: [20, 30],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_breach_uulnetol_unburdened_flesh_in_minor': {
      id: 70,
      tradeId: 'explicit.stat_66623393',
      description: 'Uul–Netol, Unburdened Flesh in your Maps has a (20–30)% chance to be Duplicated',
      range: [20, 30],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_breach_xoph_dark_embers_in_minor': {
      id: 71,
      tradeId: 'explicit.stat_482204003',
      description: 'Xoph, Dark Embers in your Maps has a (20–30)% chance to be Duplicated',
      range: [20, 30],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_breach_tul_creeping_avalanche_in_minor': {
      id: 72,
      tradeId: 'explicit.stat_4059583727',
      description: 'Tul, Creeping Avalanche in your Maps has a (20–30)% chance to be Duplicated',
      range: [20, 30],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_minor_73': {
      id: 73,
      tradeId: 'explicit.stat_2042562038',
      description: 'Breaches in your Maps have (35–45)% increased chance to contain a Breach Boss\' Clasped Hand',
      range: [35, 45],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_delirium_delirium_encounters_in_your_minor': {
      id: 74,
      tradeId: 'explicit.stat_1770833858',
      description: 'Delirium Encounters in your Maps have (6–10)% chance to generate an additional Reward type',
      range: [6, 10],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_delirium_delirium_encounters_in_your_minor_75': {
      id: 75,
      tradeId: 'explicit.stat_3962960008',
      description: 'Delirium Encounters in your Maps are (35–50)% more likely to spawn Unique Bosses',
      range: [35, 50],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_delirium_delirium_bosses_in_your_minor': {
      id: 76,
      tradeId: 'explicit.stat_405988579',
      description: 'Delirium Bosses in your Maps drop (20–30)% increased Simulacrum Splinters',
      range: [20, 30],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_delirium_delirious_monsters_killed_in_minor': {
      id: 77,
      tradeId: 'explicit.stat_3428124128',
      description: 'Delirious Monsters Killed in your Maps provide (10–20)% increased Reward Progress',
      range: [10, 20],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_delirium_delirium_monsters_in_your_minor': {
      id: 78,
      tradeId: 'explicit.stat_3465791711',
      description: 'Delirium Monsters in your Maps have (5–10)% increased Pack Size',
      range: [5, 10],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_delve_sulphite_veins_and_chests_minor': {
      id: 79,
      tradeId: 'explicit.stat_3862876997',
      description: 'Sulphite Veins and Chests in your Maps have (3–5)% chance to also contain an equal amount of Azurite',
      range: [3, 5],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_shrines_3040_increased_duration_of_minor': {
      id: 80,
      tradeId: 'explicit.stat_495713612',
      description: '(30–40)% increased Duration of Shrine Effects on Players in your Maps',
      range: [30, 40],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_essence_imprisoned_monsters_in_your_minor': {
      id: 81,
      tradeId: 'explicit.stat_1445968994',
      description: 'Imprisoned Monsters in your Maps have (40–60)% chance to drop an additional Rare Item with an Essence Modifier',
      range: [40, 60],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_essence_imprisoned_monsters_in_your_minor_82': {
      id: 82,
      tradeId: 'explicit.stat_2874244045',
      description: 'Imprisoned Monsters in your Maps have (8–12)% chance to have an additional Essence',
      range: [8, 12],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_expedition_1520_increased_explosive_radius_minor': {
      id: 83,
      tradeId: 'explicit.stat_3289828378',
      description: '(15–20)% increased Explosive Radius in your Maps',
      range: [15, 20],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_expedition_1525_increased_quantity_of_minor': {
      id: 84,
      tradeId: 'explicit.stat_1083387327',
      description: '(15–25)% increased Quantity of Expedition Logbooks dropped by Runic Monsters in your Maps',
      range: [15, 25],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_harbinger_harbingers_in_your_maps_minor': {
      id: 85,
      tradeId: 'explicit.stat_1972294007',
      description: 'Harbingers in your Maps have (20–30)% increased Cooldown Recovery Rate',
      range: [20, 30],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_harvest_harvest_monsters_in_your_minor': {
      id: 86,
      tradeId: 'explicit.stat_4251234305',
      description: 'Harvest Monsters in your Maps grant (70–90)% increased Experience',
      range: [70, 90],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_harvest_harvest_crops_in_your_minor': {
      id: 87,
      tradeId: 'explicit.stat_744497885',
      description: 'Harvest Crops in your Maps have (10–15)% reduced chance to grow Yellow Plants',
      range: [10, 15],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_harvest_harvest_crops_in_your_minor_88': {
      id: 88,
      tradeId: 'explicit.stat_1234594761',
      description: 'Harvest Crops in your Maps have (10–15)% reduced chance to grow Blue Plants',
      range: [10, 15],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_harvest_harvest_crops_in_your_minor_89': {
      id: 89,
      tradeId: 'explicit.stat_4191390667',
      description: 'Harvest Crops in your Maps have (10–15)% reduced chance to grow Purple Plants',
      range: [10, 15],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_heist_smugglers_caches_in_your_minor': {
      id: 90,
      tradeId: 'explicit.stat_2018889940',
      description: 'Smuggler\'s Caches in your Maps have (35–45)% increased chance to drop Blueprints',
      range: [35, 45],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_minor': {
      id: 91,
      tradeId: 'explicit.stat_1870692844',
      description: 'Heist Contracts found in your Maps are (40–60)% more likely to require Lockpicking, Brute Force or Perception',
      range: [40, 60],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_minor_92': {
      id: 92,
      tradeId: 'explicit.stat_3225564606',
      description: 'Heist Contracts found in your Maps are (40–60)% more likely to require Demolition, Counter–Thaumaturgy or Trap Disarmament',
      range: [40, 60],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_minor_93': {
      id: 93,
      tradeId: 'explicit.stat_496819486',
      description: 'Heist Contracts found in your Maps are (40–60)% more likely to require Agility, Deception or Engineering',
      range: [40, 60],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_in_minor': {
      id: 94,
      tradeId: 'explicit.stat_1820067107',
      description: 'Immortal Syndicate Members in your Maps are (40–60)% more likely to be accompanied by their Leader',
      range: [40, 60],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_executed_minor': {
      id: 95,
      tradeId: 'explicit.stat_3615401038',
      description: 'Immortal Syndicate Members Executed in your Maps have (40–60)% chance to gain an additional Rank',
      range: [40, 60],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_legion_legion_sergeants_in_your_minor': {
      id: 96,
      tradeId: 'explicit.stat_958835998',
      description: 'Legion Sergeants in your Maps have (6–10)% additional chance to have Rewards',
      range: [6, 10],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_minor': {
      id: 97,
      tradeId: 'explicit.stat_113049735',
      description: 'Legion Encounters in your Maps are (25–35)% more likely to include a General',
      range: [25, 35],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_legion_legion_chests_released_from_minor': {
      id: 98,
      tradeId: 'explicit.stat_793510540',
      description: 'Legion Chests released from Stasis in your Maps release other Monsters and Chests with (35–50)% increased Range',
      range: [35, 50],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_minor': {
      id: 99,
      tradeId: 'explicit.stat_1603263120',
      description: 'Ultimatum Encounters in your Maps have (15–20)% increased chance for the final Round to include a Boss',
      range: [15, 20],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_minor_100': {
      id: 100,
      tradeId: 'explicit.stat_4236665456',
      description: 'Ultimatum Encounters in your Maps have (40–60)% increased chance to require you to protect the Altar',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_rewards_in_your_minor': {
      id: 101,
      tradeId: 'explicit.stat_1280423224',
      description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Unique Items',
      range: [20, 30],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_rewards_in_your_minor_102': {
      id: 102,
      tradeId: 'explicit.stat_3814215147',
      description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Jewellery',
      range: [20, 30],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_rewards_in_your_minor_103': {
      id: 103,
      tradeId: 'explicit.stat_1656757869',
      description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Currency Items',
      range: [20, 30],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_minor_104': {
      id: 104,
      tradeId: 'explicit.stat_2014727907',
      description: 'Ultimatum Encounters in your Maps have (40–60)% increased chance to require you to defeat waves of Enemies',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_minor_105': {
      id: 105,
      tradeId: 'explicit.stat_802960755',
      description: 'Ultimatum Encounters in your Maps have (40–60)% increased chance to require you to Stand in the Stone Circles',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_rewards_in_your_minor_106': {
      id: 106,
      tradeId: 'explicit.stat_297961897',
      description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Divination Cards',
      range: [20, 30],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_rewards_in_your_minor_107': {
      id: 107,
      tradeId: 'explicit.stat_2091246228',
      description: 'Ultimatum Rewards in your Maps have (20–30)% increased chance to be Gems',
      range: [20, 30],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_minor_108': {
      id: 108,
      tradeId: 'explicit.stat_306537703',
      description: 'Ultimatum Encounters in your Maps have (40–60)% increased chance to only require you to Survive',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ritual_rerolling_favours_at_ritual_minor': {
      id: 109,
      tradeId: 'explicit.stat_2282052746',
      description: 'Rerolling Favours at Ritual Altars in your Maps costs (8–12)% reduced Tribute',
      range: [8, 12],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ritual_favours_deferred_at_ritual_minor': {
      id: 110,
      tradeId: 'explicit.stat_28208665',
      description: 'Favours Deferred at Ritual Altars in your Maps reappear (20–30)% sooner',
      range: [20, 30],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_ritual_unique_monsters_slain_at_minor': {
      id: 111,
      tradeId: 'explicit.stat_3957379603',
      description: 'Unique Monsters slain at Ritual Altars in your Maps grant (40–60)% more Tribute',
      range: [40, 60],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_in_your_maps_minor': {
      id: 112,
      tradeId: 'explicit.stat_2115623338',
      description: 'Strongboxes in your Maps have (50–70)% increased chance to be an Arcanist\'s Strongbox',
      range: [50, 70],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_in_your_maps_minor_113': {
      id: 113,
      tradeId: 'explicit.stat_3273190973',
      description: 'Strongboxes in your Maps have (50–70)% increased chance to be a Cartographer\'s Strongbox',
      range: [50, 70],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_in_your_maps_minor_114': {
      id: 114,
      tradeId: 'explicit.stat_2388239017',
      description: 'Strongboxes in your Maps have (50–70)% increased chance to be a Diviner\'s Strongbox',
      range: [50, 70],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_in_your_maps_minor_115': {
      id: 115,
      tradeId: 'explicit.stat_773912026',
      description: 'Strongboxes in your Maps have (40–60)% increased chance to be a Gemcutter\'s Strongbox',
      range: [40, 60],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_tormented_spirits_tormented_spirits_in_your_minor': {
      id: 116,
      tradeId: 'explicit.stat_663610248',
      description: 'Tormented Spirits in your Maps have (40–60)% increased Duration',
      range: [40, 60],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_scarabs_unique_monsters_in_your_minor': {
      id: 117,
      tradeId: 'explicit.stat_3190161627',
      description: 'Unique Monsters in your Maps have (75–100)% increased chance to drop Scarabs',
      range: [75, 100],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_maps_24_chance_for_scouting_minor': {
      id: 118,
      tradeId: 'explicit.stat_2703551872',
      description: '(2–4)% chance for Scouting Reports to drop as Otherworldly Scouting Reports instead in your Maps',
      range: [2, 4],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_maps_24_chance_for_scouting_minor_119': {
      id: 119,
      tradeId: 'explicit.stat_4045495237',
      description: '(2–4)% chance for Scouting Reports to drop as Delirious Scouting Reports instead in your Maps',
      range: [2, 4],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_maps_24_chance_for_scouting_minor_120': {
      id: 120,
      tradeId: 'explicit.stat_1347565511',
      description: '(2–4)% chance for Scouting Reports to drop as Blighted Scouting Reports instead in your Maps',
      range: [2, 4],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_maps_610_chance_for_scouting_minor': {
      id: 121,
      tradeId: 'explicit.stat_1385164385',
      description: '(6–10)% chance for Scouting Reports to drop as Comprehensive Scouting Reports instead in your Maps',
      range: [6, 10],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_maps_46_chance_for_scouting_minor': {
      id: 122,
      tradeId: 'explicit.stat_2327933970',
      description: '(4–6)% chance for Scouting Reports to drop as Vaal Scouting Reports instead in your Maps',
      range: [4, 6],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_maps_35_chance_for_scouting_minor': {
      id: 123,
      tradeId: 'explicit.stat_2246445775',
      description: '(3–5)% chance for Scouting Reports to drop as Operative\'s Scouting Reports instead in your Maps',
      range: [3, 5],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_maps_46_chance_for_scouting_minor_124': {
      id: 124,
      tradeId: 'explicit.stat_2681413993',
      description: '(4–6)% chance for Scouting Reports to drop as Singular Scouting Reports instead in your Maps',
      range: [4, 6],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_vaal_side_areas_items_found_in_your_minor': {
      id: 125,
      tradeId: 'explicit.stat_1407304212',
      description: 'Items found in your Corrupted Maps have (1–2)% chance to be Corrupted',
      range: [1, 2],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_vaal_side_areas_vaal_side_areas_in_minor': {
      id: 126,
      tradeId: 'explicit.stat_2063734057',
      description: 'Vaal Side Areas in your Maps have (6–10)% chance to be an Alluring Vaal Side Area',
      range: [6, 10],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_vaal_side_areas_items_dropped_by_rare_minor': {
      id: 127,
      tradeId: 'explicit.stat_2736953654',
      description: 'Items dropped by Rare Monsters have (3–5)% chance to be Corrupted',
      range: [3, 5],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_eater_of_worlds_your_maps_have_46_minor': {
      id: 128,
      tradeId: 'explicit.stat_1943774953',
      description: 'Your Maps have (4–6)% chance to award double progress towards encountering The Eater of Worlds',
      range: [4, 6],
      contentType: ContentType.EATER_OF_WORLDS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_eater_of_worlds_eldritch_ichor_found_in_minor': {
      id: 129,
      tradeId: 'explicit.stat_2157440077',
      description: 'Eldritch Ichor found in your Maps influenced by The Eater of Worlds have (4–6)% chance to be Duplicated',
      range: [4, 6],
      contentType: ContentType.EATER_OF_WORLDS,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'suffix_searing_exarch_monster_packs_influenced_by_minor': {
      id: 130,
      tradeId: 'explicit.stat_2127991449',
      description: 'Monster Packs Influenced by The Searing Exarch in your Maps have (4–6)% increased Pack Size',
      range: [4, 6],
      contentType: ContentType.SEARING_EXARCH,
      idolSizes: [IdolSize.MINOR],
      type: 'suffix'
    },
    'prefix_abyss_your_maps_have_3045_kamasan': {
      id: 131,
      tradeId: 'explicit.stat_4278144676',
      description: 'Your Maps have +(30–45)% chance to contain an Abyss',
      range: [30, 45],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_abyss_your_maps_have_144180_kamasan': {
      id: 132,
      tradeId: 'explicit.stat_4111037980',
      description: 'Your Maps have (144–180)% increased chance to contain an Abyss',
      range: [144, 180],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_3045_kamasan': {
      id: 133,
      tradeId: 'explicit.stat_2709296039',
      description: 'Your Maps have +(30–45)% chance to contain Alva',
      range: [30, 45],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_144180_kamasan': {
      id: 134,
      tradeId: 'explicit.stat_3629418990',
      description: 'Your Maps have (144–180)% increased chance to contain Alva',
      range: [144, 180],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_a_kamasan': {
      id: 135,
      tradeId: 'explicit.stat_1123357133',
      description: 'Your Maps have a (30–45)% chance to contain an additional Rogue Exile',
      range: [30, 45],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_1218_kamasan': {
      id: 136,
      tradeId: 'explicit.stat_2974922599',
      description: 'Your Maps have +(12–18)% chance to contain a Rogue Exile',
      range: [12, 18],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_3045_kamasan': {
      id: 137,
      tradeId: 'explicit.stat_1566972708',
      description: 'Your Maps have +(30–45)% chance to contain Einhar',
      range: [30, 45],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_144180_kamasan': {
      id: 138,
      tradeId: 'explicit.stat_1301096166',
      description: 'Your Maps have (144–180)% increased chance to contain Einhar',
      range: [144, 180],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_beyond_3045_chance_for_your_kamasan': {
      id: 139,
      tradeId: 'explicit.stat_3438840900',
      description: '(30–45)% chance for your Maps to attract Beyond Demons',
      range: [30, 45],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_3045_kamasan': {
      id: 140,
      tradeId: 'explicit.stat_764545335',
      description: 'Your Maps have +(30–45)% chance to contain a Blight Encounter',
      range: [30, 45],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_144180_kamasan': {
      id: 141,
      tradeId: 'explicit.stat_1393318927',
      description: 'Your Maps have (144–180)% increased chance to contain a Blight Encounter',
      range: [144, 180],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_3045_kamasan': {
      id: 142,
      tradeId: 'explicit.stat_1133841298',
      description: 'Your Maps have +(30–45)% chance to contain Breaches',
      range: [30, 45],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_144180_kamasan': {
      id: 143,
      tradeId: 'explicit.stat_2372432713',
      description: 'Your Maps have (144–180)% increased chance to contain a Breach',
      range: [144, 180],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_breach_your_maps_which_contain_kamasan': {
      id: 144,
      tradeId: 'explicit.stat_3051957033',
      description: 'Your Maps which contain Breaches have (5–10)% chance to contain two additional Breaches',
      range: [5, 10],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_3045_kamasan': {
      id: 145,
      tradeId: 'explicit.stat_1808954678',
      description: 'Your Maps have +(30–45)% chance to contain a Mirror of Delirium',
      range: [30, 45],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_144180_kamasan': {
      id: 146,
      tradeId: 'explicit.stat_3573600538',
      description: 'Your Maps have (144–180)% increased chance to contain a Mirror of Delirium',
      range: [144, 180],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_3045_kamasan': {
      id: 147,
      tradeId: 'explicit.stat_4267923742',
      description: 'Your Maps have +(30–45)% chance to contain Niko',
      range: [30, 45],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_144180_kamasan': {
      id: 148,
      tradeId: 'explicit.stat_399319107',
      description: 'Your Maps have (144–180)% increased chance to contain Niko',
      range: [144, 180],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_1218_kamasan': {
      id: 149,
      tradeId: 'explicit.stat_2571125745',
      description: 'Your Maps have +(12–18)% chance to contain a Shrine',
      range: [12, 18],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_a_kamasan': {
      id: 150,
      tradeId: 'explicit.stat_1260233365',
      description: 'Your Maps have a (60–80)% chance to contain an additional Shrine',
      range: [60, 80],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_shaper_final_map_boss_in_kamasan': {
      id: 151,
      tradeId: 'explicit.stat_931052937',
      description: 'Final Map Boss in each Map has +(1.8–2.4)% chance to drop a Shaper Guardian Map (Tier 14+)',
      range: [1.8, 2.4],
      contentType: ContentType.SHAPER,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_elder_final_map_boss_in_kamasan': {
      id: 152,
      tradeId: 'explicit.stat_1377454569',
      description: 'Final Map Boss in each Map has +(1.8–2.4)% chance to drop an Elder Guardian Map (Tier 14+)',
      range: [1.8, 2.4],
      contentType: ContentType.ELDER,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_1218_kamasan': {
      id: 153,
      tradeId: 'explicit.stat_4098286334',
      description: 'Your Maps have +(12–18)% chance to contain an Imprisoned Monster',
      range: [12, 18],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_6080_kamasan': {
      id: 154,
      tradeId: 'explicit.stat_2039130613',
      description: 'Your Maps have (60–80)% chance to contain an additional Imprisoned Monster',
      range: [60, 80],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_3045_kamasan': {
      id: 155,
      tradeId: 'explicit.stat_4154778375',
      description: 'Your Maps have +(30–45)% chance to contain an Expedition Encounter',
      range: [30, 45],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_144180_kamasan': {
      id: 156,
      tradeId: 'explicit.stat_1561678231',
      description: 'Your Maps have (144–180)% increased chance to contain an Expedition Encounter',
      range: [144, 180],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_have_a_kamasan': {
      id: 157,
      tradeId: 'explicit.stat_266448395',
      description: 'Your Maps have a (60–80)% chance to contain an additional Harbinger',
      range: [60, 80],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_3045_kamasan': {
      id: 158,
      tradeId: 'explicit.stat_1145451936',
      description: 'Your Maps have +(30–45)% chance to contain The Sacred Grove',
      range: [30, 45],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_144180_kamasan': {
      id: 159,
      tradeId: 'explicit.stat_2936740844',
      description: 'Your Maps have (144–180)% increased chance to contain The Sacred Grove',
      range: [144, 180],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_3045_kamasan': {
      id: 160,
      tradeId: 'explicit.stat_1975869602',
      description: 'Your Maps have +(30–45)% chance to contain a Smuggler\'s Cache',
      range: [30, 45],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_144180_kamasan': {
      id: 161,
      tradeId: 'explicit.stat_4069523014',
      description: 'Your Maps have (144–180)% increased chance to contain a Smuggler\'s Cache',
      range: [144, 180],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_heist_2025_increased_blueprints_found_kamasan': {
      id: 162,
      tradeId: 'explicit.stat_619910101',
      description: '(20–25)% increased Blueprints found in your Maps',
      range: [20, 25],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_3045_kamasan': {
      id: 163,
      tradeId: 'explicit.stat_527292219',
      description: 'Your Maps have +(30–45)% chance to contain Jun',
      range: [30, 45],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_144180_kamasan': {
      id: 164,
      tradeId: 'explicit.stat_4116217552',
      description: 'Your Maps have (144–180)% increased chance to contain Jun',
      range: [144, 180],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_3045_kamasan': {
      id: 165,
      tradeId: 'explicit.stat_1981273563',
      description: 'Your Maps have +(30–45)% chance to contain a Legion Encounter',
      range: [30, 45],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_144180_kamasan': {
      id: 166,
      tradeId: 'explicit.stat_310950600',
      description: 'Your Maps have (144–180)% increased chance to contain a Legion Encounter',
      range: [144, 180],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_144180_kamasan': {
      id: 167,
      tradeId: 'explicit.stat_880963174',
      description: 'Your Maps have (144–180)% increased chance to contain an Ultimatum Encounter',
      range: [144, 180],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_3045_kamasan': {
      id: 168,
      tradeId: 'explicit.stat_1365687125',
      description: 'Your Maps have +(30–45)% chance to contain an Ultimatum Encounter',
      range: [30, 45],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_3045_kamasan': {
      id: 169,
      tradeId: 'explicit.stat_1314822783',
      description: 'Your Maps have +(30–45)% chance to contain Ritual Altars',
      range: [30, 45],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_144180_kamasan': {
      id: 170,
      tradeId: 'explicit.stat_1777351949',
      description: 'Your Maps have (144–180)% increased chance to contain Ritual Altars',
      range: [144, 180],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_have_6080_kamasan': {
      id: 171,
      tradeId: 'explicit.stat_2388936716',
      description: 'Your Maps have +(60–80)% chance to contain a Strongbox',
      range: [60, 80],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_maps_1218_chance_for_a_kamasan': {
      id: 172,
      tradeId: 'explicit.stat_4098976931',
      description: '+(1.2–1.8)% chance for a Synthesis Map to drop from Final Map Boss in each Map (Tier 14+)',
      range: [1.2, 1.8],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_a_kamasan': {
      id: 173,
      tradeId: 'explicit.stat_846433713',
      description: 'Your Maps have a (60–80)% chance to be haunted by an additional Tormented Spirit',
      range: [60, 80],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_1218_kamasan': {
      id: 174,
      tradeId: 'explicit.stat_2750973094',
      description: 'Your Maps have +(12–18)% chance to be haunted by a Tormented Spirit',
      range: [12, 18],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_tormented_spirits_map_bosses_have_68_kamasan': {
      id: 175,
      tradeId: 'explicit.stat_906368454',
      description: 'Map Bosses have (6–8)% chance to be surrounded by Tormented Spirits',
      range: [6, 8],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_vaal_side_areas_your_maps_have_58_kamasan': {
      id: 176,
      tradeId: 'explicit.stat_2156201537',
      description: 'Your Maps have +(5–8)% chance to contain a Vaal Side Area',
      range: [5, 8],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'prefix_maps_58_chance_for_one_kamasan': {
      id: 177,
      tradeId: 'explicit.stat_3885184473',
      description: '(5–8)% chance for one Monster in each of your Maps to drop an additional connected Map',
      range: [5, 8],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'prefix'
    },
    'suffix_abyss_abysses_in_your_maps_kamasan': {
      id: 178,
      tradeId: 'explicit.stat_944630113',
      description: 'Abysses in your Maps spawn (12–18)% increased Monsters',
      range: [12, 18],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_abyss_abyss_monsters_in_your_kamasan': {
      id: 179,
      tradeId: 'explicit.stat_2975078312',
      description: 'Abyss Monsters in your Maps grant (30–40)% increased Experience',
      range: [30, 40],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_abyss_abyss_cracks_in_your_kamasan': {
      id: 180,
      tradeId: 'explicit.stat_211873159',
      description: 'Abyss Cracks in your Maps have (8–12)% chance to spawn 100% increased Monsters',
      range: [8, 12],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_abyss_abyss_pits_in_your_kamasan': {
      id: 181,
      tradeId: 'explicit.stat_1086708760',
      description: 'Abyss Pits in your Maps have (8–12)% chance to spawn 100% increased Monsters',
      range: [8, 12],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_abyss_abyss_cracks_in_your_kamasan_182': {
      id: 182,
      tradeId: 'explicit.stat_440232197',
      description: 'Abyss Cracks in your Maps have (3–5)% chance to spawn all Monsters as Magic for each prior Pit in that Abyss',
      range: [3, 5],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_incursion_incursions_in_your_maps_kamasan': {
      id: 183,
      tradeId: 'explicit.stat_787321478',
      description: 'Incursions in your Maps have (15–25)% chance for all Monsters to be at least Magic',
      range: [15, 25],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_rogue_exiles_3040_increased_rarity_of_kamasan': {
      id: 184,
      tradeId: 'explicit.stat_4105955491',
      description: '(30–40)% increased Rarity of Items Dropped by Wild Rogue Exiles in your Maps',
      range: [30, 40],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_rogue_exiles_rogue_exiles_in_your_kamasan': {
      id: 185,
      tradeId: 'explicit.stat_2646493318',
      description: 'Rogue Exiles in your Maps have (15–20)% chance to drop an additional Currency Item',
      range: [15, 20],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_bestiary_your_maps_that_contain_kamasan': {
      id: 186,
      tradeId: 'explicit.stat_1044770866',
      description: 'Your Maps that contain capturable Beasts have (12–18)% chance to contain an additional Red Beast',
      range: [12, 18],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_bestiary_einhar_deals_600800_more_kamasan': {
      id: 187,
      tradeId: 'explicit.stat_1709437962',
      description: 'Einhar deals (600–800)% more Damage to Unique Monsters in your Maps',
      range: [600, 800],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_bestiary_einhar_has_6080_increased_kamasan': {
      id: 188,
      tradeId: 'explicit.stat_1288839550',
      description: 'Einhar has (60–80)% increased Cooldown Recovery Rate in your Maps',
      range: [60, 80],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_beyond_beyond_portals_in_your_kamasan': {
      id: 189,
      tradeId: 'explicit.stat_1454090489',
      description: 'Beyond Portals in your Maps have (20–25)% increased Merging Radius',
      range: [20, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_beyond_1015_increased_quantity_of_kamasan': {
      id: 190,
      tradeId: 'explicit.stat_1289727785',
      description: '(10–15)% increased Quantity of Tainted Currency dropped by Beyond Demons in your Maps',
      range: [10, 15],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_blight_lanes_of_blight_encounters_kamasan': {
      id: 191,
      tradeId: 'explicit.stat_3986662538',
      description: 'Lanes of Blight Encounters in your Maps have (6–8)% chance for an additional Reward Chest',
      range: [6, 8],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_blight_1525_chance_for_blight_kamasan': {
      id: 192,
      tradeId: 'explicit.stat_1260718722',
      description: '(15–25)% chance for Blight Chests to contain an additional Reward',
      range: [15, 25],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_blight_blight_bosses_in_your_kamasan': {
      id: 193,
      tradeId: 'explicit.stat_393389663',
      description: 'Blight Bosses in your Maps have (14–18)% chance to add an additional Reward Chest when Defeated',
      range: [14, 18],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_blight_blighted_chests_in_your_kamasan': {
      id: 194,
      tradeId: 'explicit.stat_1254426365',
      description: 'Blighted Chests in your Maps have (25–35)% increased chance to contain an Oil',
      range: [25, 35],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_blight_blight_monsters_in_your_kamasan': {
      id: 195,
      tradeId: 'explicit.stat_1837341489',
      description: 'Blight Monsters in your Maps spawn (40–60)% faster',
      range: [40, 60],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_breach_bosses_in_your_kamasan': {
      id: 196,
      tradeId: 'explicit.stat_253707123',
      description: 'Breach Bosses in your Maps have (12–16)% chance to drop double Breach Splinters',
      range: [12, 16],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_2025_increased_quantity_of_kamasan': {
      id: 197,
      tradeId: 'explicit.stat_3870984748',
      description: '(20–25)% increased Quantity of Breach Splinters found in Breach Hands in your Maps',
      range: [20, 25],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_kamasan': {
      id: 198,
      tradeId: 'explicit.stat_3963266703',
      description: 'Breaches in your Maps have (80–120)% increased chance to belong to Xoph',
      range: [80, 120],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_kamasan_199': {
      id: 199,
      tradeId: 'explicit.stat_622901199',
      description: 'Breaches in your Maps have (80–120)% increased chance to belong to Tul',
      range: [80, 120],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_kamasan_200': {
      id: 200,
      tradeId: 'explicit.stat_2147182152',
      description: 'Breaches in your Maps have (80–120)% increased chance to belong to Esh',
      range: [80, 120],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_kamasan_201': {
      id: 201,
      tradeId: 'explicit.stat_2819193674',
      description: 'Breaches in your Maps have (70–100)% increased chance to belong to Uul–Netol',
      range: [70, 100],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_kamasan_202': {
      id: 202,
      tradeId: 'explicit.stat_3377019059',
      description: 'Breaches in your Maps have (60–80)% increased chance to belong to Chayula',
      range: [60, 80],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_2025_increased_quantity_of_kamasan_203': {
      id: 203,
      tradeId: 'explicit.stat_624534143',
      description: '(20–25)% increased Quantity of Breach Splinters dropped by Breach Monsters in your Maps',
      range: [20, 25],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_breach_breach_monsters_in_your_kamasan': {
      id: 204,
      tradeId: 'explicit.stat_538335880',
      description: 'Breach Monsters in your Maps have (3–7)% increased chance to drop a Breach Unique Item',
      range: [3, 7],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_searing_exarch_monsters_influenced_by_the_kamasan': {
      id: 205,
      tradeId: 'explicit.stat_532540562',
      description: 'Monsters Influenced by The Searing Exarch in your Maps have (0.5–0.7)% chance to drop an Item with a Searing Exarch Implicit Modifier',
      range: [0.5, 0.7],
      contentType: ContentType.SEARING_EXARCH,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_conquerors_monster_packs_influenced_by_kamasan': {
      id: 206,
      tradeId: 'explicit.stat_2459732614',
      description: 'Monster Packs Influenced by Conquerors in your Maps have (8–12)% increased Pack Size',
      range: [8, 12],
      contentType: ContentType.CONQUERORS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_delirium_delirium_fog_in_your_kamasan': {
      id: 207,
      tradeId: 'explicit.stat_3350944114',
      description: 'Delirium Fog in your Maps dissipates (2–5)% slower',
      range: [2, 5],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_delirium_delirium_bosses_in_your_kamasan': {
      id: 208,
      tradeId: 'explicit.stat_615948723',
      description: 'Delirium Bosses in your Maps have (30–40)% increased chance to drop Unique Cluster Jewels',
      range: [30, 40],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_delirium_delirium_monsters_in_your_kamasan': {
      id: 209,
      tradeId: 'explicit.stat_3580714718',
      description: 'Delirium Monsters in your Maps have (15–25)% increased chance to drop Cluster Jewels',
      range: [15, 25],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_delirium_cluster_jewels_from_delirium_kamasan': {
      id: 210,
      tradeId: 'explicit.stat_1975134334',
      description: 'Cluster Jewels from Delirium Rewards have a (6–8)% chance to be Rare and Corrupted',
      range: [6, 8],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_delve_voltaxic_sulphite_veins_and_kamasan': {
      id: 211,
      tradeId: 'explicit.stat_4276927142',
      description: 'Voltaxic Sulphite Veins and Chests in your Maps contain (8–10)% increased Sulphite',
      range: [8, 10],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_delve_you_gain_812_increased_kamasan': {
      id: 212,
      tradeId: 'explicit.stat_2250533757',
      description: 'You Gain (8–12)% increased Movement Speed per stack of Sulphite Intoxication.',
      range: [8, 12],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_shrines_2535_increased_effect_of_kamasan': {
      id: 213,
      tradeId: 'explicit.stat_866902458',
      description: '(25–35)% increased Effect of Shrine Buffs on Players in your Maps',
      range: [25, 35],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_essence_monsters_imprisoned_by_essences_kamasan': {
      id: 214,
      tradeId: 'explicit.stat_1439991839',
      description: 'Monsters Imprisoned by Essences have a (20–25)% chance to contain a Remnant of Corruption',
      range: [20, 25],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_expedition_1015_increased_quantity_of_kamasan': {
      id: 215,
      tradeId: 'explicit.stat_4219583418',
      description: '(10–15)% increased quantity of Artifacts dropped by Monsters',
      range: [10, 15],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_expedition_610_increased_number_of_kamasan': {
      id: 216,
      tradeId: 'explicit.stat_3051490307',
      description: '(6–10)% increased number of Explosives in your Maps',
      range: [6, 10],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_expedition_1520_increased_quantity_of_kamasan': {
      id: 217,
      tradeId: 'explicit.stat_2934907255',
      description: '(15–20)% increased Quantity of Vendor Refresh Currencies dropped by Monsters in your Maps',
      range: [15, 20],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_expedition_expedition_detonation_chains_in_kamasan': {
      id: 218,
      tradeId: 'explicit.stat_3907743910',
      description: 'Expedition Detonation Chains in your Maps travel (12–18)% slower',
      range: [12, 18],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_harbinger_harbingers_in_your_maps_kamasan': {
      id: 219,
      tradeId: 'explicit.stat_1413020589',
      description: 'Harbingers in your Maps have (40–60)% chance to drop an additional Stack of Currency Shards',
      range: [40, 60],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_harvest_harvest_crops_in_your_kamasan': {
      id: 220,
      tradeId: 'explicit.stat_1505882627',
      description: 'Harvest Crops in your Maps have (35–45)% increased chance to contain a Tier 4 Plant',
      range: [35, 45],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_harvest_harvest_crops_in_your_kamasan_221': {
      id: 221,
      tradeId: 'explicit.stat_2992379436',
      description: 'Harvest Crops in your Maps have (25–35)% increased chance to contain Tier 3 Plants',
      range: [25, 35],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_kamasan': {
      id: 222,
      tradeId: 'explicit.stat_3688987182',
      description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 3 Jobs',
      range: [75, 125],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_kamasan_223': {
      id: 223,
      tradeId: 'explicit.stat_2054538312',
      description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 4 Jobs',
      range: [75, 125],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_kamasan_224': {
      id: 224,
      tradeId: 'explicit.stat_2251697080',
      description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 5 Jobs',
      range: [75, 125],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_heist_your_maps_that_contain_kamasan': {
      id: 225,
      tradeId: 'explicit.stat_549540629',
      description: 'Your Maps that contain Smuggler\'s Caches have a (25–35)% chance to contain an additional Smuggler\'s Cache',
      range: [25, 35],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_in_kamasan': {
      id: 226,
      tradeId: 'explicit.stat_1259656520',
      description: 'Immortal Syndicate Members in your Maps are (120–160)% more likely to offer to Bargain for Items',
      range: [120, 160],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_betrayal_1624_increased_rarity_of_kamasan': {
      id: 227,
      tradeId: 'explicit.stat_4187085307',
      description: '(16–24)% increased Rarity of items from Defeated Syndicate Members in your Maps per Equipment Item they have',
      range: [16, 24],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_legion_100150_increased_rarity_of_kamasan': {
      id: 228,
      tradeId: 'explicit.stat_3617935793',
      description: '(100–150)% increased Rarity of Items Dropped by Legion Sergeants in your Maps',
      range: [100, 150],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_kamasan': {
      id: 229,
      tradeId: 'explicit.stat_699122342',
      description: 'Legion Encounters in your Maps have (40–60)% increased Duration',
      range: [40, 60],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_legion_legion_monsters_in_your_kamasan': {
      id: 230,
      tradeId: 'explicit.stat_2596927667',
      description: 'Legion Monsters in your Maps take (30–40)% increased Damage while in Stasis',
      range: [30, 40],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_legion_legion_monsters_in_your_kamasan_231': {
      id: 231,
      tradeId: 'explicit.stat_4183582609',
      description: 'Legion Monsters in your Maps have (10–15)% increased Pack Size',
      range: [10, 15],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_altars_in_your_kamasan': {
      id: 232,
      tradeId: 'explicit.stat_4281937233',
      description: 'Ultimatum Altars in your Maps have (30–40)% increased Life',
      range: [30, 40],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_stone_circles_in_kamasan': {
      id: 233,
      tradeId: 'explicit.stat_1805474879',
      description: 'Ultimatum Stone Circles in your Maps have (15–20)% increased radius',
      range: [15, 20],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_rewards_in_your_kamasan': {
      id: 234,
      tradeId: 'explicit.stat_294140055',
      description: 'Ultimatum Rewards in your Maps have (25–35)% increased chance to be Inscribed Ultimatums',
      range: [25, 35],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_kamasan': {
      id: 235,
      tradeId: 'explicit.stat_3099069648',
      description: 'Ultimatum Encounters in your Maps only requiring you to Survive have (3–5)% reduced duration',
      range: [3, 5],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_kamasan_236': {
      id: 236,
      tradeId: 'explicit.stat_340836576',
      description: 'Ultimatum Encounters in your Maps requiring you to Defeat waves of Enemies require killing (3–5)% reduced number of Enemies',
      range: [3, 5],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ritual_5075_increased_chance_of_kamasan': {
      id: 237,
      tradeId: 'explicit.stat_2172921782',
      description: '(50–75)% increased chance of Ritual Altars with Special Rewards',
      range: [50, 75],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ritual_favours_rerolled_at_ritual_kamasan': {
      id: 238,
      tradeId: 'explicit.stat_937291386',
      description: 'Favours Rerolled at Ritual Altars in your Maps have (0.8–1.2)% chance to cost no Tribute',
      range: [0.8, 1.2],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ritual_ritual_altars_in_your_kamasan': {
      id: 239,
      tradeId: 'explicit.stat_2219456349',
      description: 'Ritual Altars in your Maps can have (15–25)% increased number of Spawned Monsters at once',
      range: [15, 25],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_ritual_ritual_splinters_offered_at_kamasan': {
      id: 240,
      tradeId: 'explicit.stat_1724306833',
      description: 'Ritual Splinters offered at Ritual Altars in your Maps have (20–25)% increased Stack Size',
      range: [20, 25],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_kamasan': {
      id: 241,
      tradeId: 'explicit.stat_1762451150',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Cartography Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_found_in_your_kamasan': {
      id: 242,
      tradeId: 'explicit.stat_3017211510',
      description: 'Scarabs found in your Maps are (60–80)% more likely to be Ambush Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_kamasan_243': {
      id: 243,
      tradeId: 'explicit.stat_2584308379',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Titanic Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_kamasan_244': {
      id: 244,
      tradeId: 'explicit.stat_1560748306',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Harbinger Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_kamasan_245': {
      id: 245,
      tradeId: 'explicit.stat_2507275343',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Beyond Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_kamasan_246': {
      id: 246,
      tradeId: 'explicit.stat_751635784',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Essence Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_kamasan_247': {
      id: 247,
      tradeId: 'explicit.stat_3070577277',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Torment Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_kamasan_248': {
      id: 248,
      tradeId: 'explicit.stat_2477998669',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Domination Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_kamasan_249': {
      id: 249,
      tradeId: 'explicit.stat_723578929',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Anarchy Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_in_your_maps_kamasan': {
      id: 250,
      tradeId: 'explicit.stat_403369937',
      description: 'Strongboxes in your Maps have (40–60)% chance to be guarded by an additional Pack of Monsters',
      range: [40, 60],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_strongboxes_1520_increased_quantity_of_kamasan': {
      id: 251,
      tradeId: 'explicit.stat_1054904554',
      description: '(15–20)% increased Quantity of Items contained in Strongboxes in your Maps',
      range: [15, 20],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'suffix_tormented_spirits_tormented_spirits_have_a_kamasan': {
      id: 252,
      tradeId: 'explicit.stat_4028829918',
      description: 'Tormented Spirits have a (1–2)% chance to be set free when Possessed Monsters are slain',
      range: [1, 2],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.KAMASAN],
      type: 'suffix'
    },
    'prefix_abyss_your_maps_have_4060_totemic': {
      id: 253,
      tradeId: 'explicit.stat_4278144676',
      description: 'Your Maps have +(40–60)% chance to contain an Abyss',
      range: [40, 60],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_abyss_your_maps_have_192240_totemic': {
      id: 254,
      tradeId: 'explicit.stat_4111037980',
      description: 'Your Maps have (192–240)% increased chance to contain an Abyss',
      range: [192, 240],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_4060_totemic': {
      id: 255,
      tradeId: 'explicit.stat_2709296039',
      description: 'Your Maps have +(40–60)% chance to contain Alva',
      range: [40, 60],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_192240_totemic': {
      id: 256,
      tradeId: 'explicit.stat_3629418990',
      description: 'Your Maps have (192–240)% increased chance to contain Alva',
      range: [192, 240],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_a_totemic': {
      id: 257,
      tradeId: 'explicit.stat_1123357133',
      description: 'Your Maps have a (40–60)% chance to contain an additional Rogue Exile',
      range: [40, 60],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_1525_totemic': {
      id: 258,
      tradeId: 'explicit.stat_2974922599',
      description: 'Your Maps have +(15–25)% chance to contain a Rogue Exile',
      range: [15, 25],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_4060_totemic': {
      id: 259,
      tradeId: 'explicit.stat_1566972708',
      description: 'Your Maps have +(40–60)% chance to contain Einhar',
      range: [40, 60],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_192240_totemic': {
      id: 260,
      tradeId: 'explicit.stat_1301096166',
      description: 'Your Maps have (192–240)% increased chance to contain Einhar',
      range: [192, 240],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_beyond_4060_chance_for_your_totemic': {
      id: 261,
      tradeId: 'explicit.stat_3438840900',
      description: '(40–60)% chance for your Maps to attract Beyond Demons',
      range: [40, 60],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_4060_totemic': {
      id: 262,
      tradeId: 'explicit.stat_764545335',
      description: 'Your Maps have +(40–60)% chance to contain a Blight Encounter',
      range: [40, 60],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_192240_totemic': {
      id: 263,
      tradeId: 'explicit.stat_1393318927',
      description: 'Your Maps have (192–240)% increased chance to contain a Blight Encounter',
      range: [192, 240],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_4060_totemic': {
      id: 264,
      tradeId: 'explicit.stat_1133841298',
      description: 'Your Maps have +(40–60)% chance to contain Breaches',
      range: [40, 60],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_192240_totemic': {
      id: 265,
      tradeId: 'explicit.stat_2372432713',
      description: 'Your Maps have (192–240)% increased chance to contain a Breach',
      range: [192, 240],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_breach_your_maps_which_contain_totemic': {
      id: 266,
      tradeId: 'explicit.stat_2440265466',
      description: 'Your Maps which contain Breaches have (5–10)% chance to contain three additional Breaches',
      range: [5, 10],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_4060_totemic': {
      id: 267,
      tradeId: 'explicit.stat_1808954678',
      description: 'Your Maps have +(40–60)% chance to contain a Mirror of Delirium',
      range: [40, 60],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_192240_totemic': {
      id: 268,
      tradeId: 'explicit.stat_3573600538',
      description: 'Your Maps have (192–240)% increased chance to contain a Mirror of Delirium',
      range: [192, 240],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_4060_totemic': {
      id: 269,
      tradeId: 'explicit.stat_4267923742',
      description: 'Your Maps have +(40–60)% chance to contain Niko',
      range: [40, 60],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_192240_totemic': {
      id: 270,
      tradeId: 'explicit.stat_399319107',
      description: 'Your Maps have (192–240)% increased chance to contain Niko',
      range: [192, 240],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_contain_an_totemic': {
      id: 271,
      tradeId: 'explicit.stat_1468737867',
      description: 'Your Maps contain an additional Shrine',
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_1525_totemic': {
      id: 272,
      tradeId: 'explicit.stat_2571125745',
      description: 'Your Maps have +(15–25)% chance to contain a Shrine',
      range: [15, 25],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_essence_your_maps_contain_an_totemic': {
      id: 273,
      tradeId: 'explicit.stat_395808938',
      description: 'Your Maps contain an additional Imprisoned Monster',
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_1525_totemic': {
      id: 274,
      tradeId: 'explicit.stat_4098286334',
      description: 'Your Maps have +(15–25)% chance to contain an Imprisoned Monster',
      range: [15, 25],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_4060_totemic': {
      id: 275,
      tradeId: 'explicit.stat_4154778375',
      description: 'Your Maps have +(40–60)% chance to contain an Expedition Encounter',
      range: [40, 60],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_192240_totemic': {
      id: 276,
      tradeId: 'explicit.stat_1561678231',
      description: 'Your Maps have (192–240)% increased chance to contain an Expedition Encounter',
      range: [192, 240],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_contain_an_totemic': {
      id: 277,
      tradeId: 'explicit.stat_504850499',
      description: 'Your Maps contain an additional Harbinger',
      range: [1, 1],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_have_a_totemic': {
      id: 278,
      tradeId: 'explicit.stat_266448395',
      description: 'Your Maps have a (15–25)% chance to contain an additional Harbinger',
      range: [15, 25],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_4060_totemic': {
      id: 279,
      tradeId: 'explicit.stat_1145451936',
      description: 'Your Maps have +(40–60)% chance to contain The Sacred Grove',
      range: [40, 60],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_192240_totemic': {
      id: 280,
      tradeId: 'explicit.stat_2936740844',
      description: 'Your Maps have (192–240)% increased chance to contain The Sacred Grove',
      range: [192, 240],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_4060_totemic': {
      id: 281,
      tradeId: 'explicit.stat_1975869602',
      description: 'Your Maps have +(40–60)% chance to contain a Smuggler\'s Cache',
      range: [40, 60],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_192240_totemic': {
      id: 282,
      tradeId: 'explicit.stat_4069523014',
      description: 'Your Maps have (192–240)% increased chance to contain a Smuggler\'s Cache',
      range: [192, 240],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_4060_totemic': {
      id: 283,
      tradeId: 'explicit.stat_527292219',
      description: 'Your Maps have +(40–60)% chance to contain Jun',
      range: [40, 60],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_192240_totemic': {
      id: 284,
      tradeId: 'explicit.stat_4116217552',
      description: 'Your Maps have (192–240)% increased chance to contain Jun',
      range: [192, 240],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_lab_your_maps_have_812_totemic': {
      id: 285,
      tradeId: 'explicit.stat_495465216',
      description: 'Your Maps have +(8–12)% chance to contain a Trial of Ascendancy',
      range: [8, 12],
      contentType: ContentType.LAB,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_4060_totemic': {
      id: 286,
      tradeId: 'explicit.stat_1981273563',
      description: 'Your Maps have +(40–60)% chance to contain a Legion Encounter',
      range: [40, 60],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_192240_totemic': {
      id: 287,
      tradeId: 'explicit.stat_310950600',
      description: 'Your Maps have (192–240)% increased chance to contain a Legion Encounter',
      range: [192, 240],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_maps_final_map_boss_in_totemic': {
      id: 288,
      tradeId: 'explicit.stat_729281484',
      description: 'Final Map Boss in each Map has (4–6)% chance to drop an additional connected Map',
      range: [4, 6],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_192240_totemic': {
      id: 289,
      tradeId: 'explicit.stat_880963174',
      description: 'Your Maps have (192–240)% increased chance to contain an Ultimatum Encounter',
      range: [192, 240],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_4060_totemic': {
      id: 290,
      tradeId: 'explicit.stat_1365687125',
      description: 'Your Maps have +(40–60)% chance to contain an Ultimatum Encounter',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_4060_totemic': {
      id: 291,
      tradeId: 'explicit.stat_1314822783',
      description: 'Your Maps have +(40–60)% chance to contain Ritual Altars',
      range: [40, 60],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_192240_totemic': {
      id: 292,
      tradeId: 'explicit.stat_1777351949',
      description: 'Your Maps have (192–240)% increased chance to contain Ritual Altars',
      range: [192, 240],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_maps_812_increased_effect_of_totemic': {
      id: 293,
      tradeId: 'explicit.stat_3191123893',
      description: '(8–12)% increased effect of Explicit Modifiers on your Maps',
      range: [8, 12],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_contain_an_totemic': {
      id: 294,
      tradeId: 'explicit.stat_3240183538',
      description: 'Your Maps contain an additional Strongbox',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_have_1525_totemic': {
      id: 295,
      tradeId: 'explicit.stat_2388936716',
      description: 'Your Maps have +(15–25)% chance to contain a Strongbox',
      range: [15, 25],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_1525_totemic': {
      id: 296,
      tradeId: 'explicit.stat_2750973094',
      description: 'Your Maps have +(15–25)% chance to be haunted by a Tormented Spirit',
      range: [15, 25],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_tormented_spirits_up_to_5_rare_totemic': {
      id: 297,
      tradeId: 'explicit.stat_3788412017',
      description: 'Up to (3–5) Rare Monsters in each of your Maps are Possessed and their Minions are Touched',
      range: [1, 5],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_are_haunted_totemic': {
      id: 298,
      tradeId: 'explicit.stat_358129101',
      description: 'Your Maps are haunted by an additional Tormented Spirit',
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_maps_your_maps_have_58_totemic': {
      id: 299,
      tradeId: 'explicit.stat_2771143254',
      description: 'Your Maps have (5–8)% chance to grant an additional Kirac Mission on Completion',
      range: [5, 8],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_maps_your_maps_have_225_totemic': {
      id: 300,
      tradeId: 'explicit.stat_2771143254',
      description: 'Your Maps have (2–2.5)% chance to grant an additional Kirac Mission on Completion',
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'prefix_maps_1216_increased_rarity_of_totemic': {
      id: 301,
      tradeId: 'explicit.stat_2306002879',
      description: '(12–16)% increased Rarity of Items found in your Maps',
      range: [12, 16],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'prefix'
    },
    'suffix_abyss_abysses_in_your_maps_totemic': {
      id: 302,
      tradeId: 'explicit.stat_836430463',
      description: 'Abysses in your Maps that do not lead to an Abyssal Depths have (40–60)% increased chance to lead to a Stygian Spire',
      range: [40, 60],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_abyss_abysses_in_your_maps_totemic_303': {
      id: 303,
      tradeId: 'explicit.stat_2722831300',
      description: 'Abysses in your Maps have (40–60)% increased chance to lead to an Abyssal Depths',
      range: [40, 60],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_abyss_abyss_cracks_in_your_totemic': {
      id: 304,
      tradeId: 'explicit.stat_1388221282',
      description: 'Abyss Cracks in your Maps have (10–20)% chance to spawn all Monsters as at least Magic',
      range: [10, 20],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_abyss_abyss_pits_in_your_totemic': {
      id: 305,
      tradeId: 'explicit.stat_4157613372',
      description: 'Abyss Pits in your Maps have (10–20)% chance to spawn all Monsters as at least Magic',
      range: [10, 20],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_incursion_killing_nonresident_architects_in_totemic': {
      id: 306,
      tradeId: 'explicit.stat_1346625818',
      description: 'Killing non–resident Architects in your Maps has (30–50)% chance to add an additional Upgrade Tier to the surviving Architect\'s Room',
      range: [30, 50],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_rogue_exiles_wild_rogue_exiles_in_totemic': {
      id: 307,
      tradeId: 'explicit.stat_3034509000',
      description: 'Wild Rogue Exiles in your Maps have (75–100)% chance to be Possessed by a Tormented Spirit',
      range: [75, 100],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_bestiary_your_maps_that_contain_totemic': {
      id: 308,
      tradeId: 'explicit.stat_1320130840',
      description: 'Your Maps that contain capturable Beasts contain (3–4) additional Yellow Beasts',
      range: [3,4],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_bestiary_red_beasts_captured_in_totemic': {
      id: 309,
      tradeId: 'explicit.stat_3773225751',
      description: 'Red Beasts captured in your Maps have a (40–60)% chance to gain a Modifier that provides a chance to not to be consumed when sacrificed at the Blood Altar',
      range: [40, 60],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_bestiary_red_beasts_in_your_totemic': {
      id: 310,
      tradeId: 'explicit.stat_543949956',
      description: 'Red Beasts in your Maps have (16–24)% chance to appear in Pairs',
      range: [16, 24],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_beyond_beyond_demons_in_your_totemic': {
      id: 311,
      tradeId: 'explicit.stat_3791540252',
      description: 'Beyond Demons in your Maps grant (20–30)% increased Experience',
      range: [20, 30],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_beyond_beyond_portals_in_your_totemic': {
      id: 312,
      tradeId: 'explicit.stat_4180165115',
      description: 'Beyond Portals in your Maps have (25–35)% increased chance to spawn a Unique Boss',
      range: [25, 35],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_beyond_2025_more_divination_cards_totemic': {
      id: 313,
      tradeId: 'explicit.stat_1340524145',
      description: '(20–25)% more Divination Cards found from Beyond Demons in your Maps that are followers of K\'Tash',
      range: [20, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_beyond_2025_more_basic_currency_totemic': {
      id: 314,
      tradeId: 'explicit.stat_3062743459',
      description: '(20–25)% more Basic Currency Items found from Beyond Demons in your Maps that are followers of Beidat',
      range: [20, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_beyond_2025_more_unique_items_totemic': {
      id: 315,
      tradeId: 'explicit.stat_303527630',
      description: '(20–25)% more Unique Items found from Beyond Demons in your Maps that are followers of Ghorr',
      range: [20, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_blight_blight_encounters_in_your_totemic': {
      id: 316,
      tradeId: 'explicit.stat_4091793171',
      description: 'Blight Encounters in your Maps spawn (25–35)% more Non–Unique Monsters',
      range: [25, 35],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_blight_oils_found_in_your_totemic': {
      id: 317,
      tradeId: 'explicit.stat_3259960466',
      description: 'Oils found in your Maps have (20–25)% chance to be 1 tier higher',
      range: [20, 25],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_blight_blight_monsters_in_your_totemic': {
      id: 318,
      tradeId: 'explicit.stat_3594607722',
      description: 'Blight Monsters in your Maps take (30–40)% increased Damage',
      range: [30, 40],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_totemic': {
      id: 319,
      tradeId: 'explicit.stat_2433436306',
      description: 'Breaches in your Maps have (35–45)% increased chance to contain a Boss',
      range: [35, 45],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_breach_breachstones_dropped_by_breach_totemic': {
      id: 320,
      tradeId: 'explicit.stat_1940017254',
      description: 'Breachstones dropped by Breach Bosses in your Maps have (3–5)% chance to be Flawless',
      range: [3, 5],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_totemic_321': {
      id: 321,
      tradeId: 'explicit.stat_2504358770',
      description: 'Breaches in your Maps open and close #% fasterBreaches in your Maps open and close #% slower',
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_totemic_322': {
      id: 322,
      tradeId: 'explicit.stat_3366450262',
      description: 'Breaches in your Maps have (10–15)% chance to contain a Hand of Xesht–Ula',
      range: [10, 15],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_totemic_323': {
      id: 323,
      tradeId: 'explicit.stat_1210760818',
      description: 'Breaches in your Maps have (8–12)% increased Monster density',
      range: [8, 12],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_searing_exarch_4060_chance_to_spawn_totemic': {
      id: 324,
      tradeId: 'explicit.stat_3179686508',
      description: '(40–60)% chance to spawn a Searing Exarch Altar when the Influence of The Searing Exarch first appears in your Maps',
      range: [40, 60],
      contentType: ContentType.SEARING_EXARCH,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_delirium_delirium_in_your_maps_totemic': {
      id: 325,
      tradeId: 'explicit.stat_1769611692',
      description: 'Delirium in your Maps increases (35–50)% faster with distance from the mirror',
      range: [35, 50],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_delirium_delirium_fog_in_your_totemic': {
      id: 326,
      tradeId: 'explicit.stat_1174954559',
      description: 'Delirium Fog in your Maps lasts (10–15) additional seconds before dissipating',
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_delirium_delirium_rewards_in_your_totemic': {
      id: 327,
      tradeId: 'explicit.stat_2901714012',
      description: 'Delirium Rewards in your Maps have (8–12)% increased chance to give Delirium Orbs',
      range: [8, 12],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_delve_voltaxic_sulphite_veins_and_totemic': {
      id: 328,
      tradeId: 'explicit.stat_1174549622',
      description: 'Voltaxic Sulphite Veins and Chests in your Maps have (4–6)% chance to contain double Sulphite',
      range: [4, 6],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_delve_you_gain_3040_increased_totemic': {
      id: 329,
      tradeId: 'explicit.stat_2154246560',
      description: 'You Gain (30–40)% increased Damage per stack of Sulphite Intoxication.',
      range: [30, 40],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_shrines_shrines_in_your_maps_totemic': {
      id: 330,
      tradeId: 'explicit.stat_1751949663',
      description: 'Shrines in your Maps have (40–60)% chance to be guarded by an additional Pack of Monsters',
      range: [40, 60],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_shaper_monster_packs_influenced_by_totemic': {
      id: 331,
      tradeId: 'explicit.stat_3017475694',
      description: 'Monster Packs Influenced by The Shaper in your Maps have (15–25)% increased Pack Size',
      range: [15, 25],
      contentType: ContentType.SHAPER,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_elder_monster_packs_influenced_by_totemic': {
      id: 332,
      tradeId: 'explicit.stat_3275918621',
      description: 'Monster Packs Influenced by The Elder in your Maps have (15–25)% increased Pack Size',
      range: [15, 25],
      contentType: ContentType.ELDER,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_essence_imprisoned_monsters_in_your_totemic': {
      id: 333,
      tradeId: 'explicit.stat_3011076420',
      description: 'Imprisoned Monsters in your Maps have (12–17)% chance to have 3 additional Essences',
      range: [12, 17],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_expedition_remnants_in_your_maps_totemic': {
      id: 334,
      tradeId: 'explicit.stat_1871805225',
      description: 'Remnants in your Maps have (25–35)% chance to have an additional Suffix Modifier',
      range: [25, 35],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_totemic': {
      id: 335,
      tradeId: 'explicit.stat_2110260866',
      description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Tujen',
      range: [80, 100],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_totemic_336': {
      id: 336,
      tradeId: 'explicit.stat_3171270268',
      description: 'Expeditions in your Maps have (50–60)% increased chance to be led by Dannig',
      range: [50, 60],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_expedition_expedition_monsters_in_your_totemic': {
      id: 337,
      tradeId: 'explicit.stat_2684644644',
      description: 'Expedition Monsters in your Maps spawn with an additional (6–10)% of Life missing',
      range: [6, 10],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_totemic_338': {
      id: 338,
      tradeId: 'explicit.stat_140032086',
      description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Rog',
      range: [80, 100],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_totemic_339': {
      id: 339,
      tradeId: 'explicit.stat_159709680',
      description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Gwennen',
      range: [80, 100],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_harbinger_harbingers_in_your_maps_totemic': {
      id: 340,
      tradeId: 'explicit.stat_3511358099',
      description: 'Harbingers in your Maps have (20–25)% chance to be replaced by a powerful Harbinger boss',
      range: [20, 25],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_harvest_harvest_monsters_in_your_totemic': {
      id: 341,
      tradeId: 'explicit.stat_3483648190',
      description: 'Harvest Monsters in your Maps drop (12–18)% increased Quantity of Lifeforce',
      range: [12, 18],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_harvest_harvests_in_your_maps_totemic': {
      id: 342,
      tradeId: 'explicit.stat_1565587169',
      description: 'Harvests in your Maps have (8–12)% chance for the unchosen Crop to not wilt',
      range: [8, 12],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_harvest_the_sacred_grove_in_totemic': {
      id: 343,
      tradeId: 'explicit.stat_1880405255',
      description: 'The Sacred Grove in your Maps has (40–60)% chance to contain an additional Harvest',
      range: [40, 60],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_heist_smugglers_caches_in_your_totemic': {
      id: 344,
      tradeId: 'explicit.stat_470630932',
      description: 'Smuggler\'s Caches in your Maps have (40–60)% increased chance to drop Contracts',
      range: [40, 60],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_heist_smugglers_caches_drop_812_totemic': {
      id: 345,
      tradeId: 'explicit.stat_2863957119',
      description: 'Smuggler\'s Caches drop (8–12)% more Rogue Markers for each Smuggler\'s Cache opened in the Area',
      range: [8, 12],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_totemic': {
      id: 346,
      tradeId: 'explicit.stat_2429444272',
      description: 'Heist Contracts found in your Maps are (70–90)% more likely to target High Value Targets',
      range: [70, 90],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_totemic_347': {
      id: 347,
      tradeId: 'explicit.stat_1288317603',
      description: 'Heist Contracts found in your Maps are (45–65)% more likely to target Precious Targets',
      range: [45, 65],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_in_totemic': {
      id: 348,
      tradeId: 'explicit.stat_2181411965',
      description: 'Immortal Syndicate Members in your Maps have (20–25)% increased chance to be accompanied by reinforcements',
      range: [20, 25],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_in_totemic_349': {
      id: 349,
      tradeId: 'explicit.stat_4122946258',
      description: 'Immortal Syndicate Members in your Maps have (40–60)% chance to drop an additional Veiled Item',
      range: [40, 60],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_betrayal_4060_increased_rarity_of_totemic': {
      id: 350,
      tradeId: 'explicit.stat_2695818040',
      description: '(40–60)% increased Rarity of Items Dropped by Immortal Syndicate Members in your Maps',
      range: [40, 60],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_totemic': {
      id: 351,
      tradeId: 'explicit.stat_4094461744',
      description: 'Legion Encounters in your Maps have (100–150)% increased chance to include a Karui army',
      range: [100, 150],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_totemic_352': {
      id: 352,
      tradeId: 'explicit.stat_3825355878',
      description: 'Legion Encounters in your Maps have (100–150)% increased chance to include an Eternal Empire army',
      range: [100, 150],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_totemic_353': {
      id: 353,
      tradeId: 'explicit.stat_3218477736',
      description: 'Legion Encounters in your Maps have (80–120)% increased chance to include a Vaal army',
      range: [80, 120],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_totemic_354': {
      id: 354,
      tradeId: 'explicit.stat_573511501',
      description: 'Legion Encounters in your Maps have (75–100)% increased chance to include a Templar army',
      range: [75, 100],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_totemic_355': {
      id: 355,
      tradeId: 'explicit.stat_1611826374',
      description: 'Legion Encounters in your Maps have (60–80)% increased chance to include a Maraketh army',
      range: [60, 80],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_splinters_dropped_by_legion_totemic': {
      id: 356,
      tradeId: 'explicit.stat_3374667389',
      description: 'Splinters dropped by Legion Monsters or contained in Legion Chests in your Maps have (15–20)% chance to be Duplicated',
      range: [15, 20],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_splinters_contained_in_legion_totemic': {
      id: 357,
      tradeId: 'explicit.stat_1794950665',
      description: 'Splinters contained in Legion Chests in your Maps have (20–25)% chance to be Duplicated',
      range: [20, 25],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_splinters_dropped_by_legion_totemic_358': {
      id: 358,
      tradeId: 'explicit.stat_3473008748',
      description: 'Splinters dropped by Legion Monsters in your Maps have (20–25)% chance to be Duplicated',
      range: [20, 25],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_legion_legion_monsters_in_your_totemic': {
      id: 359,
      tradeId: 'explicit.stat_611792282',
      description: 'Legion Monsters in your Maps which have Rewards have (8–12)% chance to gain two additional Rewards, and if not have (15–20)% chance to gain one additional Reward',
      range: [8, 12],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_maps_510_increased_pack_size_totemic': {
      id: 360,
      tradeId: 'explicit.stat_631736299',
      description: '(5–10)% increased Pack Size of your Maps affected by Fortune Favours the Brave',
      range: [5, 10],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_maps_510_increased_quantity_of_totemic': {
      id: 361,
      tradeId: 'explicit.stat_2619073196',
      description: '(5–10)% increased Quantity of Items found in your Maps affected by Fortune Favours the Brave',
      range: [5, 10],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_maps_1020_increased_rarity_of_totemic': {
      id: 362,
      tradeId: 'explicit.stat_3433267351',
      description: '(10–20)% increased Rarity of Items found in your Maps affected by Fortune Favours the Brave',
      range: [10, 20],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_totemic': {
      id: 363,
      tradeId: 'explicit.stat_3025100555',
      description: 'Ultimatum Encounters in your Maps spawn (15–20)% increased number of Monsters',
      range: [15, 20],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_monsters_in_your_totemic': {
      id: 364,
      tradeId: 'explicit.stat_3027114376',
      description: 'Ultimatum Monsters in your Maps grant (40–60)% increased Experience',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_ultimatum_inscribed_ultimatums_found_in_totemic': {
      id: 365,
      tradeId: 'explicit.stat_2112979059',
      description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Unique Items',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_ultimatum_inscribed_ultimatums_found_in_totemic_366': {
      id: 366,
      tradeId: 'explicit.stat_2412871991',
      description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Currency Items',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_ultimatum_inscribed_ultimatums_found_in_totemic_367': {
      id: 367,
      tradeId: 'explicit.stat_2367226239',
      description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Divination Cards',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_ritual_monsters_sacrificed_at_ritual_totemic': {
      id: 368,
      tradeId: 'explicit.stat_159726667',
      description: 'Monsters Sacrificed at Ritual Altars in your Maps grant (20–25)% increased Tribute',
      range: [20, 25],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_ritual_ritual_altars_in_your_totemic': {
      id: 369,
      tradeId: 'explicit.stat_2428948876',
      description: 'Ritual Altars in your Maps spawn Monsters (15–20)% faster',
      range: [15, 20],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_ritual_deferring_favours_at_ritual_totemic': {
      id: 370,
      tradeId: 'explicit.stat_1345835998',
      description: 'Deferring Favours at Ritual Altars in your Maps costs (15–20)% reduced Tribute',
      range: [15, 20],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_scarabs_final_map_boss_in_totemic': {
      id: 371,
      tradeId: 'explicit.stat_4086926366',
      description: 'Final Map Boss in each Map has (20–25)% chance to drop an additional Scarab',
      range: [20, 25],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_scarabs_rare_monsters_in_your_totemic': {
      id: 372,
      tradeId: 'explicit.stat_829341851',
      description: 'Rare Monsters in your Maps have (40–60)% increased chance to drop Scarabs per Monster Modifier affecting them',
      range: [40, 60],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_strongboxes_currency_items_from_strongboxes_totemic': {
      id: 373,
      tradeId: 'explicit.stat_92114609',
      description: 'Currency Items from Strongboxes in your Maps are Duplicated',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_strongboxes_maps_from_strongboxes_in_totemic': {
      id: 374,
      tradeId: 'explicit.stat_4089738202',
      description: 'Maps from Strongboxes in your Maps are Duplicated',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_strongboxes_divination_cards_from_strongboxes_totemic': {
      id: 375,
      tradeId: 'explicit.stat_3469094021',
      description: 'Divination Cards from Strongboxes in your Maps are Duplicated',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_strongboxes_gems_contained_in_strongboxes_totemic': {
      id: 376,
      tradeId: 'explicit.stat_1992708227',
      description: 'Gems contained in Strongboxes in your Maps are Duplicated',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_eater_of_worlds_monsters_influenced_by_the_totemic': {
      id: 377,
      tradeId: 'explicit.stat_2121601076',
      description: 'Monsters Influenced by The Eater of Worlds in your Maps have (0.8–1.2)% chance to drop an item with an Eater of Worlds Implicit Modifier',
      range: [0.8, 1.2],
      contentType: ContentType.EATER_OF_WORLDS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_eater_of_worlds_1520_increased_chance_to_totemic': {
      id: 378,
      tradeId: 'explicit.stat_2988344505',
      description: '(15–20)% increased chance to find Eater of Worlds Altars in your Maps',
      range: [15, 20],
      contentType: ContentType.EATER_OF_WORLDS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_vaal_side_areas_items_dropped_by_unique_totemic': {
      id: 379,
      tradeId: 'explicit.stat_1852765051',
      description: 'Items dropped by Unique Monsters have (10–15)% chance to be Corrupted',
      range: [10, 15],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_vaal_side_areas_vaal_side_areas_in_totemic': {
      id: 380,
      tradeId: 'explicit.stat_4131593417',
      description: 'Vaal Side Areas in your Maps have (15–20)% chance for Rewards from Vaal Vessels to be Duplicated',
      range: [15, 20],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'suffix_maps_2535_increased_rarity_of_totemic': {
      id: 381,
      tradeId: 'explicit.stat_655058427',
      description: '(25–35)% increased Rarity of Maps found in your Maps',
      range: [25, 35],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.TOTEMIC],
      type: 'suffix'
    },
    'prefix_abyss_your_maps_have_3045_noble': {
      id: 382,
      tradeId: 'explicit.stat_4278144676',
      description: 'Your Maps have +(30–45)% chance to contain an Abyss',
      range: [30, 45],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_abyss_your_maps_have_144180_noble': {
      id: 383,
      tradeId: 'explicit.stat_4111037980',
      description: 'Your Maps have (144–180)% increased chance to contain an Abyss',
      range: [144, 180],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_3045_noble': {
      id: 384,
      tradeId: 'explicit.stat_2709296039',
      description: 'Your Maps have +(30–45)% chance to contain Alva',
      range: [30, 45],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_144180_noble': {
      id: 385,
      tradeId: 'explicit.stat_3629418990',
      description: 'Your Maps have (144–180)% increased chance to contain Alva',
      range: [144, 180],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_a_noble': {
      id: 386,
      tradeId: 'explicit.stat_1123357133',
      description: 'Your Maps have a (30–45)% chance to contain an additional Rogue Exile',
      range: [30, 45],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_1218_noble': {
      id: 387,
      tradeId: 'explicit.stat_2974922599',
      description: 'Your Maps have +(12–18)% chance to contain a Rogue Exile',
      range: [12, 18],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_3045_noble': {
      id: 388,
      tradeId: 'explicit.stat_1566972708',
      description: 'Your Maps have +(30–45)% chance to contain Einhar',
      range: [30, 45],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_144180_noble': {
      id: 389,
      tradeId: 'explicit.stat_1301096166',
      description: 'Your Maps have (144–180)% increased chance to contain Einhar',
      range: [144, 180],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_beyond_3045_chance_for_your_noble': {
      id: 390,
      tradeId: 'explicit.stat_3438840900',
      description: '(30–45)% chance for your Maps to attract Beyond Demons',
      range: [30, 45],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_3045_noble': {
      id: 391,
      tradeId: 'explicit.stat_764545335',
      description: 'Your Maps have +(30–45)% chance to contain a Blight Encounter',
      range: [30, 45],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_144180_noble': {
      id: 392,
      tradeId: 'explicit.stat_1393318927',
      description: 'Your Maps have (144–180)% increased chance to contain a Blight Encounter',
      range: [144, 180],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_3045_noble': {
      id: 393,
      tradeId: 'explicit.stat_1133841298',
      description: 'Your Maps have +(30–45)% chance to contain Breaches',
      range: [30, 45],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_144180_noble': {
      id: 394,
      tradeId: 'explicit.stat_2372432713',
      description: 'Your Maps have (144–180)% increased chance to contain a Breach',
      range: [144, 180],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_breach_your_maps_which_contain_noble': {
      id: 395,
      tradeId: 'explicit.stat_3051957033',
      description: 'Your Maps which contain Breaches have (5–10)% chance to contain two additional Breaches',
      range: [5, 10],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_3045_noble': {
      id: 396,
      tradeId: 'explicit.stat_1808954678',
      description: 'Your Maps have +(30–45)% chance to contain a Mirror of Delirium',
      range: [30, 45],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_144180_noble': {
      id: 397,
      tradeId: 'explicit.stat_3573600538',
      description: 'Your Maps have (144–180)% increased chance to contain a Mirror of Delirium',
      range: [144, 180],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_3045_noble': {
      id: 398,
      tradeId: 'explicit.stat_4267923742',
      description: 'Your Maps have +(30–45)% chance to contain Niko',
      range: [30, 45],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_144180_noble': {
      id: 399,
      tradeId: 'explicit.stat_399319107',
      description: 'Your Maps have (144–180)% increased chance to contain Niko',
      range: [144, 180],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_1218_noble': {
      id: 400,
      tradeId: 'explicit.stat_2571125745',
      description: 'Your Maps have +(12–18)% chance to contain a Shrine',
      range: [12, 18],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_a_noble': {
      id: 401,
      tradeId: 'explicit.stat_1260233365',
      description: 'Your Maps have a (60–80)% chance to contain an additional Shrine',
      range: [60, 80],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_shaper_final_map_boss_in_noble': {
      id: 402,
      tradeId: 'explicit.stat_931052937',
      description: 'Final Map Boss in each Map has +(1.8–2.4)% chance to drop a Shaper Guardian Map (Tier 14+)',
      range: [1.8, 2.4],
      contentType: ContentType.SHAPER,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_elder_final_map_boss_in_noble': {
      id: 403,
      tradeId: 'explicit.stat_1377454569',
      description: 'Final Map Boss in each Map has +(1.8–2.4)% chance to drop an Elder Guardian Map (Tier 14+)',
      range: [1.8, 2.4],
      contentType: ContentType.ELDER,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_1218_noble': {
      id: 404,
      tradeId: 'explicit.stat_4098286334',
      description: 'Your Maps have +(12–18)% chance to contain an Imprisoned Monster',
      range: [12, 18],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_6080_noble': {
      id: 405,
      tradeId: 'explicit.stat_2039130613',
      description: 'Your Maps have (60–80)% chance to contain an additional Imprisoned Monster',
      range: [60, 80],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_3045_noble': {
      id: 406,
      tradeId: 'explicit.stat_4154778375',
      description: 'Your Maps have +(30–45)% chance to contain an Expedition Encounter',
      range: [30, 45],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_144180_noble': {
      id: 407,
      tradeId: 'explicit.stat_1561678231',
      description: 'Your Maps have (144–180)% increased chance to contain an Expedition Encounter',
      range: [144, 180],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_have_a_noble': {
      id: 408,
      tradeId: 'explicit.stat_266448395',
      description: 'Your Maps have a (60–80)% chance to contain an additional Harbinger',
      range: [60, 80],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_3045_noble': {
      id: 409,
      tradeId: 'explicit.stat_1145451936',
      description: 'Your Maps have +(30–45)% chance to contain The Sacred Grove',
      range: [30, 45],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_144180_noble': {
      id: 410,
      tradeId: 'explicit.stat_2936740844',
      description: 'Your Maps have (144–180)% increased chance to contain The Sacred Grove',
      range: [144, 180],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_3045_noble': {
      id: 411,
      tradeId: 'explicit.stat_1975869602',
      description: 'Your Maps have +(30–45)% chance to contain a Smuggler\'s Cache',
      range: [30, 45],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_144180_noble': {
      id: 412,
      tradeId: 'explicit.stat_4069523014',
      description: 'Your Maps have (144–180)% increased chance to contain a Smuggler\'s Cache',
      range: [144, 180],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_heist_2025_increased_blueprints_found_noble': {
      id: 413,
      tradeId: 'explicit.stat_619910101',
      description: '(20–25)% increased Blueprints found in your Maps',
      range: [20, 25],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_3045_noble': {
      id: 414,
      tradeId: 'explicit.stat_527292219',
      description: 'Your Maps have +(30–45)% chance to contain Jun',
      range: [30, 45],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_144180_noble': {
      id: 415,
      tradeId: 'explicit.stat_4116217552',
      description: 'Your Maps have (144–180)% increased chance to contain Jun',
      range: [144, 180],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_3045_noble': {
      id: 416,
      tradeId: 'explicit.stat_1981273563',
      description: 'Your Maps have +(30–45)% chance to contain a Legion Encounter',
      range: [30, 45],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_144180_noble': {
      id: 417,
      tradeId: 'explicit.stat_310950600',
      description: 'Your Maps have (144–180)% increased chance to contain a Legion Encounter',
      range: [144, 180],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_144180_noble': {
      id: 418,
      tradeId: 'explicit.stat_880963174',
      description: 'Your Maps have (144–180)% increased chance to contain an Ultimatum Encounter',
      range: [144, 180],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_3045_noble': {
      id: 419,
      tradeId: 'explicit.stat_1365687125',
      description: 'Your Maps have +(30–45)% chance to contain an Ultimatum Encounter',
      range: [30, 45],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_3045_noble': {
      id: 420,
      tradeId: 'explicit.stat_1314822783',
      description: 'Your Maps have +(30–45)% chance to contain Ritual Altars',
      range: [30, 45],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_144180_noble': {
      id: 421,
      tradeId: 'explicit.stat_1777351949',
      description: 'Your Maps have (144–180)% increased chance to contain Ritual Altars',
      range: [144, 180],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_have_6080_noble': {
      id: 422,
      tradeId: 'explicit.stat_2388936716',
      description: 'Your Maps have +(60–80)% chance to contain a Strongbox',
      range: [60, 80],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_synthesis_1218_chance_for_a_noble': {
      id: 423,
      tradeId: 'explicit.stat_4098976931',
      description: '+(1.2–1.8)% chance for a Synthesis Map to drop from Final Map Boss in each Map (Tier 14+)',
      range: [1.2, 1.8],
      contentType: ContentType.SYNTHESIS,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_a_noble': {
      id: 424,
      tradeId: 'explicit.stat_846433713',
      description: 'Your Maps have a (60–80)% chance to be haunted by an additional Tormented Spirit',
      range: [60, 80],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_1218_noble': {
      id: 425,
      tradeId: 'explicit.stat_2750973094',
      description: 'Your Maps have +(12–18)% chance to be haunted by a Tormented Spirit',
      range: [12, 18],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_tormented_spirits_map_bosses_have_68_noble': {
      id: 426,
      tradeId: 'explicit.stat_906368454',
      description: 'Map Bosses have (6–8)% chance to be surrounded by Tormented Spirits',
      range: [6, 8],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_vaal_side_areas_your_maps_have_58_noble': {
      id: 427,
      tradeId: 'explicit.stat_2156201537',
      description: 'Your Maps have +(5–8)% chance to contain a Vaal Side Area',
      range: [5, 8],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'prefix_maps_58_chance_for_one_noble': {
      id: 428,
      tradeId: 'explicit.stat_3885184473',
      description: '(5–8)% chance for one Monster in each of your Maps to drop an additional connected Map',
      range: [5, 8],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.NOBLE],
      type: 'prefix'
    },
    'suffix_abyss_abysses_in_your_maps_noble': {
      id: 429,
      tradeId: 'explicit.stat_944630113',
      description: 'Abysses in your Maps spawn (12–18)% increased Monsters',
      range: [12, 18],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_abyss_abyss_monsters_in_your_noble': {
      id: 430,
      tradeId: 'explicit.stat_2975078312',
      description: 'Abyss Monsters in your Maps grant (30–40)% increased Experience',
      range: [30, 40],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_abyss_abyss_cracks_in_your_noble': {
      id: 431,
      tradeId: 'explicit.stat_211873159',
      description: 'Abyss Cracks in your Maps have (8–12)% chance to spawn 100% increased Monsters',
      range: [8, 12],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_abyss_abyss_pits_in_your_noble': {
      id: 432,
      tradeId: 'explicit.stat_1086708760',
      description: 'Abyss Pits in your Maps have (8–12)% chance to spawn 100% increased Monsters',
      range: [8, 12],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_abyss_abyss_cracks_in_your_noble_433': {
      id: 433,
      tradeId: 'explicit.stat_440232197',
      description: 'Abyss Cracks in your Maps have (3–5)% chance to spawn all Monsters as Magic for each prior Pit in that Abyss',
      range: [3, 5],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_incursion_incursions_in_your_maps_noble': {
      id: 434,
      tradeId: 'explicit.stat_787321478',
      description: 'Incursions in your Maps have (15–25)% chance for all Monsters to be at least Magic',
      range: [15, 25],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_rogue_exiles_3040_increased_rarity_of_noble': {
      id: 435,
      tradeId: 'explicit.stat_4105955491',
      description: '(30–40)% increased Rarity of Items Dropped by Wild Rogue Exiles in your Maps',
      range: [30, 40],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_rogue_exiles_rogue_exiles_in_your_noble': {
      id: 436,
      tradeId: 'explicit.stat_2646493318',
      description: 'Rogue Exiles in your Maps have (15–20)% chance to drop an additional Currency Item',
      range: [15, 20],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_bestiary_your_maps_that_contain_noble': {
      id: 437,
      tradeId: 'explicit.stat_1044770866',
      description: 'Your Maps that contain capturable Beasts have (12–18)% chance to contain an additional Red Beast',
      range: [12, 18],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_bestiary_einhar_deals_600800_more_noble': {
      id: 438,
      tradeId: 'explicit.stat_1709437962',
      description: 'Einhar deals (600–800)% more Damage to Unique Monsters in your Maps',
      range: [600, 800],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_bestiary_einhar_has_6080_increased_noble': {
      id: 439,
      tradeId: 'explicit.stat_1288839550',
      description: 'Einhar has (60–80)% increased Cooldown Recovery Rate in your Maps',
      range: [60, 80],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_beyond_beyond_portals_in_your_noble': {
      id: 440,
      tradeId: 'explicit.stat_1454090489',
      description: 'Beyond Portals in your Maps have (20–25)% increased Merging Radius',
      range: [20, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_beyond_1015_increased_quantity_of_noble': {
      id: 441,
      tradeId: 'explicit.stat_1289727785',
      description: '(10–15)% increased Quantity of Tainted Currency dropped by Beyond Demons in your Maps',
      range: [10, 15],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_blight_lanes_of_blight_encounters_noble': {
      id: 442,
      tradeId: 'explicit.stat_3986662538',
      description: 'Lanes of Blight Encounters in your Maps have (6–8)% chance for an additional Reward Chest',
      range: [6, 8],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_blight_1525_chance_for_blight_noble': {
      id: 443,
      tradeId: 'explicit.stat_1260718722',
      description: '(15–25)% chance for Blight Chests to contain an additional Reward',
      range: [15, 25],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_blight_blight_bosses_in_your_noble': {
      id: 444,
      tradeId: 'explicit.stat_393389663',
      description: 'Blight Bosses in your Maps have (14–18)% chance to add an additional Reward Chest when Defeated',
      range: [14, 18],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_blight_blighted_chests_in_your_noble': {
      id: 445,
      tradeId: 'explicit.stat_1254426365',
      description: 'Blighted Chests in your Maps have (25–35)% increased chance to contain an Oil',
      range: [25, 35],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_blight_blight_monsters_in_your_noble': {
      id: 446,
      tradeId: 'explicit.stat_1837341489',
      description: 'Blight Monsters in your Maps spawn (40–60)% faster',
      range: [40, 60],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_breach_bosses_in_your_noble': {
      id: 447,
      tradeId: 'explicit.stat_253707123',
      description: 'Breach Bosses in your Maps have (12–16)% chance to drop double Breach Splinters',
      range: [12, 16],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_2025_increased_quantity_of_noble': {
      id: 448,
      tradeId: 'explicit.stat_3870984748',
      description: '(20–25)% increased Quantity of Breach Splinters found in Breach Hands in your Maps',
      range: [20, 25],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_noble': {
      id: 449,
      tradeId: 'explicit.stat_3963266703',
      description: 'Breaches in your Maps have (80–120)% increased chance to belong to Xoph',
      range: [80, 120],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_noble_450': {
      id: 450,
      tradeId: 'explicit.stat_622901199',
      description: 'Breaches in your Maps have (80–120)% increased chance to belong to Tul',
      range: [80, 120],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_noble_451': {
      id: 451,
      tradeId: 'explicit.stat_2147182152',
      description: 'Breaches in your Maps have (80–120)% increased chance to belong to Esh',
      range: [80, 120],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_noble_452': {
      id: 452,
      tradeId: 'explicit.stat_2819193674',
      description: 'Breaches in your Maps have (70–100)% increased chance to belong to Uul–Netol',
      range: [70, 100],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_noble_453': {
      id: 453,
      tradeId: 'explicit.stat_3377019059',
      description: 'Breaches in your Maps have (60–80)% increased chance to belong to Chayula',
      range: [60, 80],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_2025_increased_quantity_of_noble_454': {
      id: 454,
      tradeId: 'explicit.stat_624534143',
      description: '(20–25)% increased Quantity of Breach Splinters dropped by Breach Monsters in your Maps',
      range: [20, 25],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_breach_breach_monsters_in_your_noble': {
      id: 455,
      tradeId: 'explicit.stat_538335880',
      description: 'Breach Monsters in your Maps have (3–7)% increased chance to drop a Breach Unique Item',
      range: [3, 7],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_searing_exarch_monsters_influenced_by_the_noble': {
      id: 456,
      tradeId: 'explicit.stat_532540562',
      description: 'Monsters Influenced by The Searing Exarch in your Maps have (0.5–0.7)% chance to drop an Item with a Searing Exarch Implicit Modifier',
      range: [0.5, 0.7],
      contentType: ContentType.SEARING_EXARCH,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_conquerors_monster_packs_influenced_by_noble': {
      id: 457,
      tradeId: 'explicit.stat_2459732614',
      description: 'Monster Packs Influenced by Conquerors in your Maps have (8–12)% increased Pack Size',
      range: [8, 12],
      contentType: ContentType.CONQUERORS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_delirium_delirium_fog_in_your_noble': {
      id: 458,
      tradeId: 'explicit.stat_3350944114',
      description: 'Delirium Fog in your Maps dissipates (2–5)% slower',
      range: [2, 5],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_delirium_delirium_bosses_in_your_noble': {
      id: 459,
      tradeId: 'explicit.stat_615948723',
      description: 'Delirium Bosses in your Maps have (30–40)% increased chance to drop Unique Cluster Jewels',
      range: [30, 40],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_delirium_delirium_monsters_in_your_noble': {
      id: 460,
      tradeId: 'explicit.stat_3580714718',
      description: 'Delirium Monsters in your Maps have (15–25)% increased chance to drop Cluster Jewels',
      range: [15, 25],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_delirium_cluster_jewels_from_delirium_noble': {
      id: 461,
      tradeId: 'explicit.stat_1975134334',
      description: 'Cluster Jewels from Delirium Rewards have a (6–8)% chance to be Rare and Corrupted',
      range: [6, 8],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_delve_voltaxic_sulphite_veins_and_noble': {
      id: 462,
      tradeId: 'explicit.stat_4276927142',
      description: 'Voltaxic Sulphite Veins and Chests in your Maps contain (8–10)% increased Sulphite',
      range: [8, 10],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_delve_you_gain_812_increased_noble': {
      id: 463,
      tradeId: 'explicit.stat_2250533757',
      description: 'You Gain (8–12)% increased Movement Speed per stack of Sulphite Intoxication.',
      range: [8, 12],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_shrines_2535_increased_effect_of_noble': {
      id: 464,
      tradeId: 'explicit.stat_866902458',
      description: '(25–35)% increased Effect of Shrine Buffs on Players in your Maps',
      range: [25, 35],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_essence_monsters_imprisoned_by_essences_noble': {
      id: 465,
      tradeId: 'explicit.stat_1439991839',
      description: 'Monsters Imprisoned by Essences have a (20–25)% chance to contain a Remnant of Corruption',
      range: [20, 25],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_expedition_1015_increased_quantity_of_noble': {
      id: 466,
      tradeId: 'explicit.stat_4219583418',
      description: '(10–15)% increased quantity of Artifacts dropped by Monsters',
      range: [10, 15],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_expedition_610_increased_number_of_noble': {
      id: 467,
      tradeId: 'explicit.stat_3051490307',
      description: '(6–10)% increased number of Explosives in your Maps',
      range: [6, 10],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_expedition_1520_increased_quantity_of_noble': {
      id: 468,
      tradeId: 'explicit.stat_2934907255',
      description: '(15–20)% increased Quantity of Vendor Refresh Currencies dropped by Monsters in your Maps',
      range: [15, 20],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_expedition_expedition_detonation_chains_in_noble': {
      id: 469,
      tradeId: 'explicit.stat_3907743910',
      description: 'Expedition Detonation Chains in your Maps travel (12–18)% slower',
      range: [12, 18],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_harbinger_harbingers_in_your_maps_noble': {
      id: 470,
      tradeId: 'explicit.stat_1413020589',
      description: 'Harbingers in your Maps have (40–60)% chance to drop an additional Stack of Currency Shards',
      range: [40, 60],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_harvest_harvest_crops_in_your_noble': {
      id: 471,
      tradeId: 'explicit.stat_1505882627',
      description: 'Harvest Crops in your Maps have (35–45)% increased chance to contain a Tier 4 Plant',
      range: [35, 45],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_harvest_harvest_crops_in_your_noble_472': {
      id: 472,
      tradeId: 'explicit.stat_2992379436',
      description: 'Harvest Crops in your Maps have (25–35)% increased chance to contain Tier 3 Plants',
      range: [25, 35],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_noble': {
      id: 473,
      tradeId: 'explicit.stat_3688987182',
      description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 3 Jobs',
      range: [75, 125],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_noble_474': {
      id: 474,
      tradeId: 'explicit.stat_2054538312',
      description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 4 Jobs',
      range: [75, 125],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_noble_475': {
      id: 475,
      tradeId: 'explicit.stat_2251697080',
      description: 'Heist Contracts found in your Maps are (75–125)% more likely to require level 5 Jobs',
      range: [75, 125],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_heist_your_maps_that_contain_noble': {
      id: 476,
      tradeId: 'explicit.stat_549540629',
      description: 'Your Maps that contain Smuggler\'s Caches have a (25–35)% chance to contain an additional Smuggler\'s Cache',
      range: [25, 35],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_in_noble': {
      id: 477,
      tradeId: 'explicit.stat_1259656520',
      description: 'Immortal Syndicate Members in your Maps are (120–160)% more likely to offer to Bargain for Items',
      range: [120, 160],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_betrayal_1624_increased_rarity_of_noble': {
      id: 478,
      tradeId: 'explicit.stat_4187085307',
      description: '(16–24)% increased Rarity of items from Defeated Syndicate Members in your Maps per Equipment Item they have',
      range: [16, 24],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_legion_100150_increased_rarity_of_noble': {
      id: 479,
      tradeId: 'explicit.stat_3617935793',
      description: '(100–150)% increased Rarity of Items Dropped by Legion Sergeants in your Maps',
      range: [100, 150],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_noble': {
      id: 480,
      tradeId: 'explicit.stat_699122342',
      description: 'Legion Encounters in your Maps have (40–60)% increased Duration',
      range: [40, 60],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_legion_legion_monsters_in_your_noble': {
      id: 481,
      tradeId: 'explicit.stat_2596927667',
      description: 'Legion Monsters in your Maps take (30–40)% increased Damage while in Stasis',
      range: [30, 40],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_legion_legion_monsters_in_your_noble_482': {
      id: 482,
      tradeId: 'explicit.stat_4183582609',
      description: 'Legion Monsters in your Maps have (10–15)% increased Pack Size',
      range: [10, 15],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_altars_in_your_noble': {
      id: 483,
      tradeId: 'explicit.stat_4281937233',
      description: 'Ultimatum Altars in your Maps have (30–40)% increased Life',
      range: [30, 40],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_stone_circles_in_noble': {
      id: 484,
      tradeId: 'explicit.stat_1805474879',
      description: 'Ultimatum Stone Circles in your Maps have (15–20)% increased radius',
      range: [15, 20],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_rewards_in_your_noble': {
      id: 485,
      tradeId: 'explicit.stat_294140055',
      description: 'Ultimatum Rewards in your Maps have (25–35)% increased chance to be Inscribed Ultimatums',
      range: [25, 35],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_noble': {
      id: 486,
      tradeId: 'explicit.stat_3099069648',
      description: 'Ultimatum Encounters in your Maps only requiring you to Survive have (3–5)% reduced duration',
      range: [3, 5],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_noble_487': {
      id: 487,
      tradeId: 'explicit.stat_340836576',
      description: 'Ultimatum Encounters in your Maps requiring you to Defeat waves of Enemies require killing (3–5)% reduced number of Enemies',
      range: [3, 5],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ritual_5075_increased_chance_of_noble': {
      id: 488,
      tradeId: 'explicit.stat_2172921782',
      description: '(50–75)% increased chance of Ritual Altars with Special Rewards',
      range: [50, 75],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ritual_favours_rerolled_at_ritual_noble': {
      id: 489,
      tradeId: 'explicit.stat_937291386',
      description: 'Favours Rerolled at Ritual Altars in your Maps have (0.8–1.2)% chance to cost no Tribute',
      range: [0.8, 1.2],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ritual_ritual_altars_in_your_noble': {
      id: 490,
      tradeId: 'explicit.stat_2219456349',
      description: 'Ritual Altars in your Maps can have (15–25)% increased number of Spawned Monsters at once',
      range: [15, 25],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_ritual_ritual_splinters_offered_at_noble': {
      id: 491,
      tradeId: 'explicit.stat_1724306833',
      description: 'Ritual Splinters offered at Ritual Altars in your Maps have (20–25)% increased Stack Size',
      range: [20, 25],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_noble': {
      id: 492,
      tradeId: 'explicit.stat_1762451150',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Cartography Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_found_in_your_noble': {
      id: 493,
      tradeId: 'explicit.stat_3017211510',
      description: 'Scarabs found in your Maps are (60–80)% more likely to be Ambush Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_noble_494': {
      id: 494,
      tradeId: 'explicit.stat_2584308379',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Titanic Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_noble_495': {
      id: 495,
      tradeId: 'explicit.stat_1560748306',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Harbinger Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_noble_496': {
      id: 496,
      tradeId: 'explicit.stat_2507275343',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Beyond Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_noble_497': {
      id: 497,
      tradeId: 'explicit.stat_751635784',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Essence Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_noble_498': {
      id: 498,
      tradeId: 'explicit.stat_3070577277',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Torment Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_noble_499': {
      id: 499,
      tradeId: 'explicit.stat_2477998669',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Domination Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_dropped_in_your_noble_500': {
      id: 500,
      tradeId: 'explicit.stat_723578929',
      description: 'Scarabs dropped in your Maps are (60–80)% more likely to be Anarchy Scarabs',
      range: [60, 80],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_in_your_maps_noble': {
      id: 501,
      tradeId: 'explicit.stat_403369937',
      description: 'Strongboxes in your Maps have (40–60)% chance to be guarded by an additional Pack of Monsters',
      range: [40, 60],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_strongboxes_1520_increased_quantity_of_noble': {
      id: 502,
      tradeId: 'explicit.stat_1054904554',
      description: '(15–20)% increased Quantity of Items contained in Strongboxes in your Maps',
      range: [15, 20],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'suffix_tormented_spirits_tormented_spirits_have_a_noble': {
      id: 503,
      tradeId: 'explicit.stat_4028829918',
      description: 'Tormented Spirits have a (1–2)% chance to be set free when Possessed Monsters are slain',
      range: [1, 2],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.NOBLE],
      type: 'suffix'
    },
    'prefix_abyss_your_maps_have_4060_burial': {
      id: 504,
      tradeId: 'explicit.stat_4278144676',
      description: 'Your Maps have +(40–60)% chance to contain an Abyss',
      range: [40, 60],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_abyss_your_maps_have_192240_burial': {
      id: 505,
      tradeId: 'explicit.stat_4111037980',
      description: 'Your Maps have (192–240)% increased chance to contain an Abyss',
      range: [192, 240],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_4060_burial': {
      id: 506,
      tradeId: 'explicit.stat_2709296039',
      description: 'Your Maps have +(40–60)% chance to contain Alva',
      range: [40, 60],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_192240_burial': {
      id: 507,
      tradeId: 'explicit.stat_3629418990',
      description: 'Your Maps have (192–240)% increased chance to contain Alva',
      range: [192, 240],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_a_burial': {
      id: 508,
      tradeId: 'explicit.stat_1123357133',
      description: 'Your Maps have a (40–60)% chance to contain an additional Rogue Exile',
      range: [40, 60],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_1525_burial': {
      id: 509,
      tradeId: 'explicit.stat_2974922599',
      description: 'Your Maps have +(15–25)% chance to contain a Rogue Exile',
      range: [15, 25],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_4060_burial': {
      id: 510,
      tradeId: 'explicit.stat_1566972708',
      description: 'Your Maps have +(40–60)% chance to contain Einhar',
      range: [40, 60],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_192240_burial': {
      id: 511,
      tradeId: 'explicit.stat_1301096166',
      description: 'Your Maps have (192–240)% increased chance to contain Einhar',
      range: [192, 240],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_beyond_4060_chance_for_your_burial': {
      id: 512,
      tradeId: 'explicit.stat_3438840900',
      description: '(40–60)% chance for your Maps to attract Beyond Demons',
      range: [40, 60],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_4060_burial': {
      id: 513,
      tradeId: 'explicit.stat_764545335',
      description: 'Your Maps have +(40–60)% chance to contain a Blight Encounter',
      range: [40, 60],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_192240_burial': {
      id: 514,
      tradeId: 'explicit.stat_1393318927',
      description: 'Your Maps have (192–240)% increased chance to contain a Blight Encounter',
      range: [192, 240],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_4060_burial': {
      id: 515,
      tradeId: 'explicit.stat_1133841298',
      description: 'Your Maps have +(40–60)% chance to contain Breaches',
      range: [40, 60],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_192240_burial': {
      id: 516,
      tradeId: 'explicit.stat_2372432713',
      description: 'Your Maps have (192–240)% increased chance to contain a Breach',
      range: [192, 240],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_breach_your_maps_which_contain_burial': {
      id: 517,
      tradeId: 'explicit.stat_2440265466',
      description: 'Your Maps which contain Breaches have (5–10)% chance to contain three additional Breaches',
      range: [5, 10],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_4060_burial': {
      id: 518,
      tradeId: 'explicit.stat_1808954678',
      description: 'Your Maps have +(40–60)% chance to contain a Mirror of Delirium',
      range: [40, 60],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_192240_burial': {
      id: 519,
      tradeId: 'explicit.stat_3573600538',
      description: 'Your Maps have (192–240)% increased chance to contain a Mirror of Delirium',
      range: [192, 240],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_4060_burial': {
      id: 520,
      tradeId: 'explicit.stat_4267923742',
      description: 'Your Maps have +(40–60)% chance to contain Niko',
      range: [40, 60],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_192240_burial': {
      id: 521,
      tradeId: 'explicit.stat_399319107',
      description: 'Your Maps have (192–240)% increased chance to contain Niko',
      range: [192, 240],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_contain_an_burial': {
      id: 522,
      tradeId: 'explicit.stat_1468737867',
      description: 'Your Maps contain an additional Shrine',
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_1525_burial': {
      id: 523,
      tradeId: 'explicit.stat_2571125745',
      description: 'Your Maps have +(15–25)% chance to contain a Shrine',
      range: [15, 25],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_essence_your_maps_contain_an_burial': {
      id: 524,
      tradeId: 'explicit.stat_395808938',
      description: 'Your Maps contain an additional Imprisoned Monster',
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_1525_burial': {
      id: 525,
      tradeId: 'explicit.stat_4098286334',
      description: 'Your Maps have +(15–25)% chance to contain an Imprisoned Monster',
      range: [15, 25],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_4060_burial': {
      id: 526,
      tradeId: 'explicit.stat_4154778375',
      description: 'Your Maps have +(40–60)% chance to contain an Expedition Encounter',
      range: [40, 60],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_192240_burial': {
      id: 527,
      tradeId: 'explicit.stat_1561678231',
      description: 'Your Maps have (192–240)% increased chance to contain an Expedition Encounter',
      range: [192, 240],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_contain_an_burial': {
      id: 528,
      tradeId: 'explicit.stat_504850499',
      description: 'Your Maps contain an additional Harbinger',
      range: [1, 1],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_have_a_burial': {
      id: 529,
      tradeId: 'explicit.stat_266448395',
      description: 'Your Maps have a (15–25)% chance to contain an additional Harbinger',
      range: [15, 25],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_4060_burial': {
      id: 530,
      tradeId: 'explicit.stat_1145451936',
      description: 'Your Maps have +(40–60)% chance to contain The Sacred Grove',
      range: [40, 60],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_192240_burial': {
      id: 531,
      tradeId: 'explicit.stat_2936740844',
      description: 'Your Maps have (192–240)% increased chance to contain The Sacred Grove',
      range: [192, 240],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_4060_burial': {
      id: 532,
      tradeId: 'explicit.stat_1975869602',
      description: 'Your Maps have +(40–60)% chance to contain a Smuggler\'s Cache',
      range: [40, 60],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_192240_burial': {
      id: 533,
      tradeId: 'explicit.stat_4069523014',
      description: 'Your Maps have (192–240)% increased chance to contain a Smuggler\'s Cache',
      range: [192, 240],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_4060_burial': {
      id: 534,
      tradeId: 'explicit.stat_527292219',
      description: 'Your Maps have +(40–60)% chance to contain Jun',
      range: [40, 60],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_192240_burial': {
      id: 535,
      tradeId: 'explicit.stat_4116217552',
      description: 'Your Maps have (192–240)% increased chance to contain Jun',
      range: [192, 240],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_lab_your_maps_have_812_burial': {
      id: 536,
      tradeId: 'explicit.stat_495465216',
      description: 'Your Maps have +(8–12)% chance to contain a Trial of Ascendancy',
      range: [8, 12],
      contentType: ContentType.LAB,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_4060_burial': {
      id: 537,
      tradeId: 'explicit.stat_1981273563',
      description: 'Your Maps have +(40–60)% chance to contain a Legion Encounter',
      range: [40, 60],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_192240_burial': {
      id: 538,
      tradeId: 'explicit.stat_310950600',
      description: 'Your Maps have (192–240)% increased chance to contain a Legion Encounter',
      range: [192, 240],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_maps_final_map_boss_in_burial': {
      id: 539,
      tradeId: 'explicit.stat_729281484',
      description: 'Final Map Boss in each Map has (4–6)% chance to drop an additional connected Map',
      range: [4, 6],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_192240_burial': {
      id: 540,
      tradeId: 'explicit.stat_880963174',
      description: 'Your Maps have (192–240)% increased chance to contain an Ultimatum Encounter',
      range: [192, 240],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_4060_burial': {
      id: 541,
      tradeId: 'explicit.stat_1365687125',
      description: 'Your Maps have +(40–60)% chance to contain an Ultimatum Encounter',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_4060_burial': {
      id: 542,
      tradeId: 'explicit.stat_1314822783',
      description: 'Your Maps have +(40–60)% chance to contain Ritual Altars',
      range: [40, 60],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_192240_burial': {
      id: 543,
      tradeId: 'explicit.stat_1777351949',
      description: 'Your Maps have (192–240)% increased chance to contain Ritual Altars',
      range: [192, 240],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_maps_812_increased_effect_of_burial': {
      id: 544,
      tradeId: 'explicit.stat_3191123893',
      description: '(8–12)% increased effect of Explicit Modifiers on your Maps',
      range: [8, 12],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_contain_an_burial': {
      id: 545,
      tradeId: 'explicit.stat_3240183538',
      description: 'Your Maps contain an additional Strongbox',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_have_1525_burial': {
      id: 546,
      tradeId: 'explicit.stat_2388936716',
      description: 'Your Maps have +(15–25)% chance to contain a Strongbox',
      range: [15, 25],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_1525_burial': {
      id: 547,
      tradeId: 'explicit.stat_2750973094',
      description: 'Your Maps have +(15–25)% chance to be haunted by a Tormented Spirit',
      range: [15, 25],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_tormented_spirits_up_to_5_rare_burial': {
      id: 548,
      tradeId: 'explicit.stat_3788412017',
      description: 'Up to 5 Rare Monsters in each of your Maps are Possessed and their Minions are Touched',
      range: [3, 5],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_are_haunted_burial': {
      id: 549,
      tradeId: 'explicit.stat_358129101',
      description: 'Your Maps are haunted by an additional Tormented Spirit',
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_maps_your_maps_have_58_burial': {
      id: 550,
      tradeId: 'explicit.stat_2771143254',
      description: 'Your Maps have (5–8)% chance to grant an additional Kirac Mission on Completion',
      range: [5, 8],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_maps_your_maps_have_225_burial': {
      id: 551,
      tradeId: 'explicit.stat_2771143254',
      description: 'Your Maps have (2–2.5)% chance to grant an additional Kirac Mission on Completion',
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'prefix_maps_1216_increased_rarity_of_burial': {
      id: 552,
      tradeId: 'explicit.stat_2306002879',
      description: '(12–16)% increased Rarity of Items found in your Maps',
      range: [12, 16],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'prefix'
    },
    'suffix_abyss_abysses_in_your_maps_burial': {
      id: 553,
      tradeId: 'explicit.stat_836430463',
      description: 'Abysses in your Maps that do not lead to an Abyssal Depths have (40–60)% increased chance to lead to a Stygian Spire',
      range: [40, 60],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_abyss_abysses_in_your_maps_burial_554': {
      id: 554,
      tradeId: 'explicit.stat_2722831300',
      description: 'Abysses in your Maps have (40–60)% increased chance to lead to an Abyssal Depths',
      range: [40, 60],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_abyss_abyss_cracks_in_your_burial': {
      id: 555,
      tradeId: 'explicit.stat_1388221282',
      description: 'Abyss Cracks in your Maps have (10–20)% chance to spawn all Monsters as at least Magic',
      range: [10, 20],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_abyss_abyss_pits_in_your_burial': {
      id: 556,
      tradeId: 'explicit.stat_4157613372',
      description: 'Abyss Pits in your Maps have (10–20)% chance to spawn all Monsters as at least Magic',
      range: [10, 20],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_incursion_killing_nonresident_architects_in_burial': {
      id: 557,
      tradeId: 'explicit.stat_1346625818',
      description: 'Killing non–resident Architects in your Maps has (30–50)% chance to add an additional Upgrade Tier to the surviving Architect\'s Room',
      range: [30, 50],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_rogue_exiles_wild_rogue_exiles_in_burial': {
      id: 558,
      tradeId: 'explicit.stat_3034509000',
      description: 'Wild Rogue Exiles in your Maps have (75–100)% chance to be Possessed by a Tormented Spirit',
      range: [75, 100],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_bestiary_your_maps_that_contain_burial': {
      id: 559,
      tradeId: 'explicit.stat_1320130840',
      description: 'Your Maps that contain capturable Beasts contain (3–4) additional Yellow Beasts',
      range: [3,4],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_bestiary_red_beasts_captured_in_burial': {
      id: 560,
      tradeId: 'explicit.stat_3773225751',
      description: 'Red Beasts captured in your Maps have a (40–60)% chance to gain a Modifier that provides a chance to not to be consumed when sacrificed at the Blood Altar',
      range: [40, 60],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_bestiary_red_beasts_in_your_burial': {
      id: 561,
      tradeId: 'explicit.stat_543949956',
      description: 'Red Beasts in your Maps have (16–24)% chance to appear in Pairs',
      range: [16, 24],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_beyond_beyond_demons_in_your_burial': {
      id: 562,
      tradeId: 'explicit.stat_3791540252',
      description: 'Beyond Demons in your Maps grant (20–30)% increased Experience',
      range: [20, 30],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_beyond_beyond_portals_in_your_burial': {
      id: 563,
      tradeId: 'explicit.stat_4180165115',
      description: 'Beyond Portals in your Maps have (25–35)% increased chance to spawn a Unique Boss',
      range: [25, 35],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_beyond_2025_more_divination_cards_burial': {
      id: 564,
      tradeId: 'explicit.stat_1340524145',
      description: '(20–25)% more Divination Cards found from Beyond Demons in your Maps that are followers of K\'Tash',
      range: [20, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_beyond_2025_more_basic_currency_burial': {
      id: 565,
      tradeId: 'explicit.stat_3062743459',
      description: '(20–25)% more Basic Currency Items found from Beyond Demons in your Maps that are followers of Beidat',
      range: [20, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_beyond_2025_more_unique_items_burial': {
      id: 566,
      tradeId: 'explicit.stat_303527630',
      description: '(20–25)% more Unique Items found from Beyond Demons in your Maps that are followers of Ghorr',
      range: [20, 25],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_blight_blight_encounters_in_your_burial': {
      id: 567,
      tradeId: 'explicit.stat_4091793171',
      description: 'Blight Encounters in your Maps spawn (25–35)% more Non–Unique Monsters',
      range: [25, 35],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_blight_oils_found_in_your_burial': {
      id: 568,
      tradeId: 'explicit.stat_3259960466',
      description: 'Oils found in your Maps have (20–25)% chance to be 1 tier higher',
      range: [20, 25],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_blight_blight_monsters_in_your_burial': {
      id: 569,
      tradeId: 'explicit.stat_3594607722',
      description: 'Blight Monsters in your Maps take (30–40)% increased Damage',
      range: [30, 40],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_burial': {
      id: 570,
      tradeId: 'explicit.stat_2433436306',
      description: 'Breaches in your Maps have (35–45)% increased chance to contain a Boss',
      range: [35, 45],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_breach_breachstones_dropped_by_breach_burial': {
      id: 571,
      tradeId: 'explicit.stat_1940017254',
      description: 'Breachstones dropped by Breach Bosses in your Maps have (3–5)% chance to be Flawless',
      range: [3, 5],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_burial_572': {
      id: 572,
      tradeId: 'explicit.stat_2504358770',
      description: 'Breaches in your Maps open and close #% fasterBreaches in your Maps open and close #% slower',
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_burial_573': {
      id: 573,
      tradeId: 'explicit.stat_3366450262',
      description: 'Breaches in your Maps have (10–15)% chance to contain a Hand of Xesht–Ula',
      range: [10, 15],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_burial_574': {
      id: 574,
      tradeId: 'explicit.stat_1210760818',
      description: 'Breaches in your Maps have (8–12)% increased Monster density',
      range: [8, 12],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_searing_exarch_4060_chance_to_spawn_burial': {
      id: 575,
      tradeId: 'explicit.stat_3179686508',
      description: '(40–60)% chance to spawn a Searing Exarch Altar when the Influence of The Searing Exarch first appears in your Maps',
      range: [40, 60],
      contentType: ContentType.SEARING_EXARCH,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_delirium_delirium_in_your_maps_burial': {
      id: 576,
      tradeId: 'explicit.stat_1769611692',
      description: 'Delirium in your Maps increases (35–50)% faster with distance from the mirror',
      range: [35, 50],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_delirium_delirium_fog_in_your_burial': {
      id: 577,
      tradeId: 'explicit.stat_1174954559',
      description: 'Delirium Fog in your Maps lasts (10–15) additional seconds before dissipating',
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_delirium_delirium_rewards_in_your_burial': {
      id: 578,
      tradeId: 'explicit.stat_2901714012',
      description: 'Delirium Rewards in your Maps have (8–12)% increased chance to give Delirium Orbs',
      range: [8, 12],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_delve_voltaxic_sulphite_veins_and_burial': {
      id: 579,
      tradeId: 'explicit.stat_1174549622',
      description: 'Voltaxic Sulphite Veins and Chests in your Maps have (4–6)% chance to contain double Sulphite',
      range: [4, 6],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_delve_you_gain_3040_increased_burial': {
      id: 580,
      tradeId: 'explicit.stat_2154246560',
      description: 'You Gain (30–40)% increased Damage per stack of Sulphite Intoxication.',
      range: [30, 40],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_shrines_shrines_in_your_maps_burial': {
      id: 581,
      tradeId: 'explicit.stat_1751949663',
      description: 'Shrines in your Maps have (40–60)% chance to be guarded by an additional Pack of Monsters',
      range: [40, 60],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_shaper_monster_packs_influenced_by_burial': {
      id: 582,
      tradeId: 'explicit.stat_3017475694',
      description: 'Monster Packs Influenced by The Shaper in your Maps have (15–25)% increased Pack Size',
      range: [15, 25],
      contentType: ContentType.SHAPER,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_elder_monster_packs_influenced_by_burial': {
      id: 583,
      tradeId: 'explicit.stat_3275918621',
      description: 'Monster Packs Influenced by The Elder in your Maps have (15–25)% increased Pack Size',
      range: [15, 25],
      contentType: ContentType.ELDER,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_essence_imprisoned_monsters_in_your_burial': {
      id: 584,
      tradeId: 'explicit.stat_3011076420',
      description: 'Imprisoned Monsters in your Maps have (12–17)% chance to have 3 additional Essences',
      range: [12, 17],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_expedition_remnants_in_your_maps_burial': {
      id: 585,
      tradeId: 'explicit.stat_1871805225',
      description: 'Remnants in your Maps have (25–35)% chance to have an additional Suffix Modifier',
      range: [25, 35],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_burial': {
      id: 586,
      tradeId: 'explicit.stat_2110260866',
      description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Tujen',
      range: [80, 100],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_burial_587': {
      id: 587,
      tradeId: 'explicit.stat_3171270268',
      description: 'Expeditions in your Maps have (50–60)% increased chance to be led by Dannig',
      range: [50, 60],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_expedition_expedition_monsters_in_your_burial': {
      id: 588,
      tradeId: 'explicit.stat_2684644644',
      description: 'Expedition Monsters in your Maps spawn with an additional (6–10)% of Life missing',
      range: [6, 10],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_burial_589': {
      id: 589,
      tradeId: 'explicit.stat_140032086',
      description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Rog',
      range: [80, 100],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_burial_590': {
      id: 590,
      tradeId: 'explicit.stat_159709680',
      description: 'Expeditions in your Maps have (80–100)% increased chance to be led by Gwennen',
      range: [80, 100],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_harbinger_harbingers_in_your_maps_burial': {
      id: 591,
      tradeId: 'explicit.stat_3511358099',
      description: 'Harbingers in your Maps have (20–25)% chance to be replaced by a powerful Harbinger boss',
      range: [20, 25],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_harvest_harvest_monsters_in_your_burial': {
      id: 592,
      tradeId: 'explicit.stat_3483648190',
      description: 'Harvest Monsters in your Maps drop (12–18)% increased Quantity of Lifeforce',
      range: [12, 18],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_harvest_harvests_in_your_maps_burial': {
      id: 593,
      tradeId: 'explicit.stat_1565587169',
      description: 'Harvests in your Maps have (8–12)% chance for the unchosen Crop to not wilt',
      range: [8, 12],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_harvest_the_sacred_grove_in_burial': {
      id: 594,
      tradeId: 'explicit.stat_1880405255',
      description: 'The Sacred Grove in your Maps has (40–60)% chance to contain an additional Harvest',
      range: [40, 60],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_heist_smugglers_caches_in_your_burial': {
      id: 595,
      tradeId: 'explicit.stat_470630932',
      description: 'Smuggler\'s Caches in your Maps have (40–60)% increased chance to drop Contracts',
      range: [40, 60],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_heist_smugglers_caches_drop_812_burial': {
      id: 596,
      tradeId: 'explicit.stat_2863957119',
      description: 'Smuggler\'s Caches drop (8–12)% more Rogue Markers for each Smuggler\'s Cache opened in the Area',
      range: [8, 12],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_burial': {
      id: 597,
      tradeId: 'explicit.stat_2429444272',
      description: 'Heist Contracts found in your Maps are (70–90)% more likely to target High Value Targets',
      range: [70, 90],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_heist_heist_contracts_found_in_burial_598': {
      id: 598,
      tradeId: 'explicit.stat_1288317603',
      description: 'Heist Contracts found in your Maps are (45–65)% more likely to target Precious Targets',
      range: [45, 65],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_in_burial': {
      id: 599,
      tradeId: 'explicit.stat_2181411965',
      description: 'Immortal Syndicate Members in your Maps have (20–25)% increased chance to be accompanied by reinforcements',
      range: [20, 25],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_in_burial_600': {
      id: 600,
      tradeId: 'explicit.stat_4122946258',
      description: 'Immortal Syndicate Members in your Maps have (40–60)% chance to drop an additional Veiled Item',
      range: [40, 60],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_betrayal_4060_increased_rarity_of_burial': {
      id: 601,
      tradeId: 'explicit.stat_2695818040',
      description: '(40–60)% increased Rarity of Items Dropped by Immortal Syndicate Members in your Maps',
      range: [40, 60],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_burial': {
      id: 602,
      tradeId: 'explicit.stat_4094461744',
      description: 'Legion Encounters in your Maps have (100–150)% increased chance to include a Karui army',
      range: [100, 150],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_burial_603': {
      id: 603,
      tradeId: 'explicit.stat_3825355878',
      description: 'Legion Encounters in your Maps have (100–150)% increased chance to include an Eternal Empire army',
      range: [100, 150],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_burial_604': {
      id: 604,
      tradeId: 'explicit.stat_3218477736',
      description: 'Legion Encounters in your Maps have (80–120)% increased chance to include a Vaal army',
      range: [80, 120],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_burial_605': {
      id: 605,
      tradeId: 'explicit.stat_573511501',
      description: 'Legion Encounters in your Maps have (75–100)% increased chance to include a Templar army',
      range: [75, 100],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_burial_606': {
      id: 606,
      tradeId: 'explicit.stat_1611826374',
      description: 'Legion Encounters in your Maps have (60–80)% increased chance to include a Maraketh army',
      range: [60, 80],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_splinters_dropped_by_legion_burial': {
      id: 607,
      tradeId: 'explicit.stat_3374667389',
      description: 'Splinters dropped by Legion Monsters or contained in Legion Chests in your Maps have (15–20)% chance to be Duplicated',
      range: [15, 20],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_splinters_contained_in_legion_burial': {
      id: 608,
      tradeId: 'explicit.stat_1794950665',
      description: 'Splinters contained in Legion Chests in your Maps have (20–25)% chance to be Duplicated',
      range: [20, 25],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_splinters_dropped_by_legion_burial_609': {
      id: 609,
      tradeId: 'explicit.stat_3473008748',
      description: 'Splinters dropped by Legion Monsters in your Maps have (20–25)% chance to be Duplicated',
      range: [20, 25],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_legion_legion_monsters_in_your_burial': {
      id: 610,
      tradeId: 'explicit.stat_611792282',
      description: 'Legion Monsters in your Maps which have Rewards have (8–12)% chance to gain two additional Rewards, and if not have (15–20)% chance to gain one additional Reward',
      range: [8, 12],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_maps_510_increased_pack_size_burial': {
      id: 611,
      tradeId: 'explicit.stat_631736299',
      description: '(5–10)% increased Pack Size of your Maps affected by Fortune Favours the Brave',
      range: [5, 10],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_maps_510_increased_quantity_of_burial': {
      id: 612,
      tradeId: 'explicit.stat_2619073196',
      description: '(5–10)% increased Quantity of Items found in your Maps affected by Fortune Favours the Brave',
      range: [5, 10],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_maps_1020_increased_rarity_of_burial': {
      id: 613,
      tradeId: 'explicit.stat_3433267351',
      description: '(10–20)% increased Rarity of Items found in your Maps affected by Fortune Favours the Brave',
      range: [10, 20],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_burial': {
      id: 614,
      tradeId: 'explicit.stat_3025100555',
      description: 'Ultimatum Encounters in your Maps spawn (15–20)% increased number of Monsters',
      range: [15, 20],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_monsters_in_your_burial': {
      id: 615,
      tradeId: 'explicit.stat_3027114376',
      description: 'Ultimatum Monsters in your Maps grant (40–60)% increased Experience',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_ultimatum_inscribed_ultimatums_found_in_burial': {
      id: 616,
      tradeId: 'explicit.stat_2112979059',
      description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Unique Items',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_ultimatum_inscribed_ultimatums_found_in_burial_617': {
      id: 617,
      tradeId: 'explicit.stat_2412871991',
      description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Currency Items',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_ultimatum_inscribed_ultimatums_found_in_burial_618': {
      id: 618,
      tradeId: 'explicit.stat_2367226239',
      description: 'Inscribed Ultimatums found in your Maps have (40–60)% increased chance to reward Divination Cards',
      range: [40, 60],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_ritual_monsters_sacrificed_at_ritual_burial': {
      id: 619,
      tradeId: 'explicit.stat_159726667',
      description: 'Monsters Sacrificed at Ritual Altars in your Maps grant (20–25)% increased Tribute',
      range: [20, 25],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_ritual_ritual_altars_in_your_burial': {
      id: 620,
      tradeId: 'explicit.stat_2428948876',
      description: 'Ritual Altars in your Maps spawn Monsters (15–20)% faster',
      range: [15, 20],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_ritual_deferring_favours_at_ritual_burial': {
      id: 621,
      tradeId: 'explicit.stat_1345835998',
      description: 'Deferring Favours at Ritual Altars in your Maps costs (15–20)% reduced Tribute',
      range: [15, 20],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_scarabs_final_map_boss_in_burial': {
      id: 622,
      tradeId: 'explicit.stat_4086926366',
      description: 'Final Map Boss in each Map has (20–25)% chance to drop an additional Scarab',
      range: [20, 25],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_scarabs_rare_monsters_in_your_burial': {
      id: 623,
      tradeId: 'explicit.stat_829341851',
      description: 'Rare Monsters in your Maps have (40–60)% increased chance to drop Scarabs per Monster Modifier affecting them',
      range: [40, 60],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_strongboxes_currency_items_from_strongboxes_burial': {
      id: 624,
      tradeId: 'explicit.stat_92114609',
      description: 'Currency Items from Strongboxes in your Maps are Duplicated',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_strongboxes_maps_from_strongboxes_in_burial': {
      id: 625,
      tradeId: 'explicit.stat_4089738202',
      description: 'Maps from Strongboxes in your Maps are Duplicated',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_strongboxes_divination_cards_from_strongboxes_burial': {
      id: 626,
      tradeId: 'explicit.stat_3469094021',
      description: 'Divination Cards from Strongboxes in your Maps are Duplicated',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_strongboxes_gems_contained_in_strongboxes_burial': {
      id: 627,
      tradeId: 'explicit.stat_1992708227',
      description: 'Gems contained in Strongboxes in your Maps are Duplicated',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_eater_of_worlds_monsters_influenced_by_the_burial': {
      id: 628,
      tradeId: 'explicit.stat_2121601076',
      description: 'Monsters Influenced by The Eater of Worlds in your Maps have (0.8–1.2)% chance to drop an item with an Eater of Worlds Implicit Modifier',
      range: [0.8, 1.2],
      contentType: ContentType.EATER_OF_WORLDS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_eater_of_worlds_1520_increased_chance_to_burial': {
      id: 629,
      tradeId: 'explicit.stat_2988344505',
      description: '(15–20)% increased chance to find Eater of Worlds Altars in your Maps',
      range: [15, 20],
      contentType: ContentType.EATER_OF_WORLDS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_vaal_side_areas_items_dropped_by_unique_burial': {
      id: 630,
      tradeId: 'explicit.stat_1852765051',
      description: 'Items dropped by Unique Monsters have (10–15)% chance to be Corrupted',
      range: [10, 15],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_vaal_side_areas_vaal_side_areas_in_burial': {
      id: 631,
      tradeId: 'explicit.stat_4131593417',
      description: 'Vaal Side Areas in your Maps have (15–20)% chance for Rewards from Vaal Vessels to be Duplicated',
      range: [15, 20],
      contentType: ContentType.VAAL_SIDE_AREAS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'suffix_maps_2535_increased_rarity_of_burial': {
      id: 632,
      tradeId: 'explicit.stat_655058427',
      description: '(25–35)% increased Rarity of Maps found in your Maps',
      range: [25, 35],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.BURIAL],
      type: 'suffix'
    },
    'prefix_abyss_your_maps_have_4570_conqueror': {
      id: 633,
      tradeId: 'explicit.stat_4278144676',
      description: 'Your Maps have +(45–70)% chance to contain an Abyss',
      range: [45, 70],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_abyss_your_maps_have_224280_conqueror': {
      id: 634,
      tradeId: 'explicit.stat_4111037980',
      description: 'Your Maps have (224–280)% increased chance to contain an Abyss',
      range: [224, 280],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_abyss_your_maps_have_35_conqueror': {
      id: 635,
      tradeId: 'explicit.stat_827686764',
      description: 'Your Maps have +(3–5)% chance to contain an Abyss per 2% increased Pack Size',
      range: [3, 5],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_4570_conqueror': {
      id: 636,
      tradeId: 'explicit.stat_2709296039',
      description: 'Your Maps have +(45–70)% chance to contain Alva',
      range: [45, 70],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_incursion_your_maps_have_224280_conqueror': {
      id: 637,
      tradeId: 'explicit.stat_3629418990',
      description: 'Your Maps have (224–280)% increased chance to contain Alva',
      range: [224, 280],
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_a_conqueror': {
      id: 638,
      tradeId: 'explicit.stat_776258428',
      description: 'Your Maps have a (8–12)% chance to contain (6–10) additional Rogue Exiles',
      range: [8, 12],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_a_conqueror_639': {
      id: 639,
      tradeId: 'explicit.stat_1123357133',
      description: 'Your Maps have a (45–70)% chance to contain an additional Rogue Exile',
      range: [45, 70],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_rogue_exiles_your_maps_have_2030_conqueror': {
      id: 640,
      tradeId: 'explicit.stat_2974922599',
      description: 'Your Maps have +(20–30)% chance to contain a Rogue Exile',
      range: [20, 30],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_4570_conqueror': {
      id: 641,
      tradeId: 'explicit.stat_1566972708',
      description: 'Your Maps have +(45–70)% chance to contain Einhar',
      range: [45, 70],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_bestiary_your_maps_have_224280_conqueror': {
      id: 642,
      tradeId: 'explicit.stat_1301096166',
      description: 'Your Maps have (224–280)% increased chance to contain Einhar',
      range: [224, 280],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_beyond_4570_chance_for_your_conqueror': {
      id: 643,
      tradeId: 'explicit.stat_3438840900',
      description: '(45–70)% chance for your Maps to attract Beyond Demons',
      range: [45, 70],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_4570_conqueror': {
      id: 644,
      tradeId: 'explicit.stat_764545335',
      description: 'Your Maps have +(45–70)% chance to contain a Blight Encounter',
      range: [45, 70],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_blight_your_maps_have_224280_conqueror': {
      id: 645,
      tradeId: 'explicit.stat_1393318927',
      description: 'Your Maps have (224–280)% increased chance to contain a Blight Encounter',
      range: [224, 280],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_4570_conqueror': {
      id: 646,
      tradeId: 'explicit.stat_1133841298',
      description: 'Your Maps have +(45–70)% chance to contain Breaches',
      range: [45, 70],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_breach_your_maps_have_224280_conqueror': {
      id: 647,
      tradeId: 'explicit.stat_2372432713',
      description: 'Your Maps have (224–280)% increased chance to contain a Breach',
      range: [224, 280],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_breach_your_maps_which_contain_conqueror': {
      id: 648,
      tradeId: 'explicit.stat_2714721644',
      description: 'Your Maps which contain Breaches have (1–2)% chance to contain ten additional Breaches',
      range: [1, 2],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_4570_conqueror': {
      id: 649,
      tradeId: 'explicit.stat_1808954678',
      description: 'Your Maps have +(45–70)% chance to contain a Mirror of Delirium',
      range: [45, 70],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_delirium_your_maps_have_224280_conqueror': {
      id: 650,
      tradeId: 'explicit.stat_3573600538',
      description: 'Your Maps have (224–280)% increased chance to contain a Mirror of Delirium',
      range: [224, 280],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_delirium_maps_found_in_your_conqueror': {
      id: 651,
      tradeId: 'explicit.stat_1482478377',
      description: 'Maps found in your Maps have (3–5)% chance to have layers of Delirium',
      range: [3, 5],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_4570_conqueror': {
      id: 652,
      tradeId: 'explicit.stat_4267923742',
      description: 'Your Maps have +(45–70)% chance to contain Niko',
      range: [45, 70],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_delve_your_maps_have_224280_conqueror': {
      id: 653,
      tradeId: 'explicit.stat_399319107',
      description: 'Your Maps have (224–280)% increased chance to contain Niko',
      range: [224, 280],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_contain_an_conqueror': {
      id: 654,
      tradeId: 'explicit.stat_1468737867',
      description: 'Your Maps contain an additional Shrine (1–2)',
      range: [1, 2],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_shrines_your_maps_have_2030_conqueror': {
      id: 655,
      tradeId: 'explicit.stat_2571125745',
      description: 'Your Maps have +(20–30)% chance to contain a Shrine',
      range: [20, 30],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_essence_your_maps_contain_an_conqueror': {
      id: 656,
      tradeId: 'explicit.stat_395808938',
      description: 'Your Maps contain an additional Imprisoned Monster (1–2)',
      range: [1, 2],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_essence_your_maps_have_2030_conqueror': {
      id: 657,
      tradeId: 'explicit.stat_4098286334',
      description: 'Your Maps have +(20–30)% chance to contain an Imprisoned Monster',
      range: [20, 30],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_4570_conqueror': {
      id: 658,
      tradeId: 'explicit.stat_4154778375',
      description: 'Your Maps have +(45–70)% chance to contain an Expedition Encounter',
      range: [45, 70],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_expedition_your_maps_have_224280_conqueror': {
      id: 659,
      tradeId: 'explicit.stat_1561678231',
      description: 'Your Maps have (224–280)% increased chance to contain an Expedition Encounter',
      range: [224, 280],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_contain_an_conqueror': {
      id: 660,
      tradeId: 'explicit.stat_504850499',
      description: 'Your Maps contain an additional Harbinger (1–2)',
      range: [1, 2],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_harbinger_your_maps_have_a_conqueror': {
      id: 661,
      tradeId: 'explicit.stat_266448395',
      description: 'Your Maps have a (20–30)% chance to contain an additional Harbinger',
      range: [20, 30],
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_4570_conqueror': {
      id: 662,
      tradeId: 'explicit.stat_1145451936',
      description: 'Your Maps have +(45–70)% chance to contain The Sacred Grove',
      range: [45, 70],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_harvest_your_maps_have_224280_conqueror': {
      id: 663,
      tradeId: 'explicit.stat_2936740844',
      description: 'Your Maps have (224–280)% increased chance to contain The Sacred Grove',
      range: [224, 280],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_4570_conqueror': {
      id: 664,
      tradeId: 'explicit.stat_1975869602',
      description: 'Your Maps have +(45–70)% chance to contain a Smuggler\'s Cache',
      range: [45, 70],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_heist_your_maps_have_224280_conqueror': {
      id: 665,
      tradeId: 'explicit.stat_4069523014',
      description: 'Your Maps have (224–280)% increased chance to contain a Smuggler\'s Cache',
      range: [224, 280],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_4570_conqueror': {
      id: 666,
      tradeId: 'explicit.stat_527292219',
      description: 'Your Maps have +(45–70)% chance to contain Jun',
      range: [45, 70],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_betrayal_your_maps_have_224280_conqueror': {
      id: 667,
      tradeId: 'explicit.stat_4116217552',
      description: 'Your Maps have (224–280)% increased chance to contain Jun',
      range: [224, 280],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_4570_conqueror': {
      id: 668,
      tradeId: 'explicit.stat_1981273563',
      description: 'Your Maps have +(45–70)% chance to contain a Legion Encounter',
      range: [45, 70],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_legion_your_maps_have_224280_conqueror': {
      id: 669,
      tradeId: 'explicit.stat_310950600',
      description: 'Your Maps have (224–280)% increased chance to contain a Legion Encounter',
      range: [224, 280],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_maps_812_chance_on_completing_conqueror': {
      id: 670,
      tradeId: 'explicit.stat_2721059969',
      description: '(8–12)% chance on Completing your Maps to gain a free use of a random Map Crafting option',
      range: [8, 12],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_maps_34_chance_on_completing_conqueror': {
      id: 671,
      tradeId: 'explicit.stat_3858757876',
      description: '(3–4)% chance on Completing your Maps to gain a free use of a special Map Crafting option',
      range: [3, 4],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_224280_conqueror': {
      id: 672,
      tradeId: 'explicit.stat_880963174',
      description: 'Your Maps have (224–280)% increased chance to contain an Ultimatum Encounter',
      range: [224, 280],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_ultimatum_your_maps_have_4570_conqueror': {
      id: 673,
      tradeId: 'explicit.stat_1365687125',
      description: 'Your Maps have +(45–70)% chance to contain an Ultimatum Encounter',
      range: [45, 70],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_4570_conqueror': {
      id: 674,
      tradeId: 'explicit.stat_1314822783',
      description: 'Your Maps have +(45–70)% chance to contain Ritual Altars',
      range: [45, 70],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_ritual_your_maps_have_224280_conqueror': {
      id: 675,
      tradeId: 'explicit.stat_1777351949',
      description: 'Your Maps have (224–280)% increased chance to contain Ritual Altars',
      range: [224, 280],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_contain_an_12_conqueror': {
      id: 676,
      tradeId: 'explicit.stat_3240183538',
      description: 'Your Maps contain an additional Strongbox (1–2)',
      range: [1, 2],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_strongboxes_your_maps_have_2030_conqueror': {
      id: 677,
      tradeId: 'explicit.stat_2388936716',
      description: 'Your Maps have +(20–30)% chance to contain a Strongbox',
      range: [20, 30],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_have_2030_conqueror': {
      id: 678,
      tradeId: 'explicit.stat_2750973094',
      description: 'Your Maps have +(20–30)% chance to be haunted by a Tormented Spirit',
      range: [20, 30],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_tormented_spirits_your_maps_are_haunted_conqueror': {
      id: 679,
      tradeId: 'explicit.stat_358129101',
      description: 'Your Maps are haunted by an additional Tormented Spirit (1–2)',
      range: [1, 2],
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_maps_46_increased_quantity_of_conqueror': {
      id: 680,
      tradeId: 'explicit.stat_2390685262',
      description: '(4–6)% increased Quantity of Items found in your Maps',
      range: [4, 6],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_maps_46_increased_pack_size_conqueror': {
      id: 681,
      tradeId: 'explicit.stat_2017682521',
      description: '(4–6)% increased Pack size',
      range: [4, 6],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_maps_35_increased_effect_of_conqueror': {
      id: 682,
      tradeId: 'explicit.stat_2490189905',
      description: '(3–5)% increased effect of Explicit Modifiers on your Maps per 5% Map Quality',
      range: [3, 5],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'prefix_maps_23_increased_effect_of_conqueror': {
      id: 683,
      tradeId: 'explicit.stat_2792863714',
      description: '(2–3)% increased effect of Explicit Modifiers on your Maps per Explicit Modifier',
      range: [2, 3],
      contentType: ContentType.MAPS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'prefix'
    },
    'suffix_abyss_abyss_jewels_found_in_conqueror': {
      id: 684,
      tradeId: 'explicit.stat_4842372',
      description: 'Abyss Jewels found in Abyssal Troves or dropped by Stygian Spires in your Maps have (15–25)% chance to be Corrupted and have 5 or 6 random Modifiers',
      range: [15, 25],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_abyss_abyss_jewels_dropped_by_conqueror': {
      id: 685,
      tradeId: 'explicit.stat_286869897',
      description: 'Abyss Jewels dropped by Abyssal Troves or Stygian Spires in your Maps have a 1% Chance to be Rare and Corrupted',
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_abyss_abyss_pits_in_your_conqueror': {
      id: 686,
      tradeId: 'explicit.stat_4049011082',
      description: 'Abyss Pits in your Maps have (14–20)% chance to spawn 5 additional Rare Monsters',
      range: [14, 20],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_abyss_abyssal_troves_and_stygian_conqueror': {
      id: 687,
      tradeId: 'explicit.stat_1028265433',
      description: 'Abyssal Troves and Stygian Spires in your Maps have (0.03–0.05)% chance to drop an Abyss Scarab',
      range: [0.03, 0.05],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_abyss_abysses_in_your_maps_conqueror': {
      id: 688,
      tradeId: 'explicit.stat_1977826050',
      description: 'Abysses in your Maps that do not lead to an Abyssal Depths lead to 4 Pits if able',
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_abyss_abysses_in_your_maps_conqueror_689': {
      id: 689,
      tradeId: 'explicit.stat_911724954',
      description: 'Abysses in your Maps that do not lead to an Abyssal Depths lead to at least 3 Pits if able',
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_abyss_abysses_in_your_maps_conqueror_690': {
      id: 690,
      tradeId: 'explicit.stat_1927544133',
      description: 'Abysses in your Maps spawn (8–12)% increased Monsters for each prior Pit in that Abyss',
      range: [8, 12],
      contentType: ContentType.ABYSS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_incursion_killing_resident_architects_in_conqueror': {
      id: 691,
      tradeId: 'explicit.stat_3052174721',
      description: 'Killing resident Architects in your Maps adds their Upgrade Tier to the surviving Architect\'s Room',
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_incursion_incursions_in_your_maps_conqueror': {
      id: 692,
      tradeId: 'explicit.stat_1822007489',
      description: 'Incursions in your Maps contain a Vaal Flesh Merchant',
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_incursion_your_maps_with_incursions_conqueror': {
      id: 693,
      tradeId: 'explicit.stat_4224761993',
      description: 'Your Maps with Incursions always have four Incursions',
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_incursion_time_gained_from_kills_conqueror': {
      id: 694,
      tradeId: 'explicit.stat_1927424401',
      description: 'Time gained from Kills is Doubled for Incursions in your Maps',
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_incursion_incursions_in_your_maps_conqueror_695': {
      id: 695,
      tradeId: 'explicit.stat_1419687153',
      description: 'Incursions in your Maps contain Cursed Treasures',
      contentType: ContentType.INCURSION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_rogue_exiles_wild_rogue_exiles_in_conqueror': {
      id: 696,
      tradeId: 'explicit.stat_113499389',
      description: 'Wild Rogue Exiles in your Maps have (40–60)% chance to have additional Rewards',
      range: [40, 60],
      contentType: ContentType.ROGUE_EXILES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_bestiary_beasts_in_your_maps_conqueror': {
      id: 697,
      tradeId: 'explicit.stat_4062346714',
      description: 'Beasts in your Maps are more likely to be less common varieties',
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_bestiary_einhar_remains_in_your_conqueror': {
      id: 698,
      tradeId: 'explicit.stat_1766031838',
      description: 'Einhar remains in your Maps after his Mission is Complete',
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_bestiary_yellow_beasts_in_your_conqueror': {
      id: 699,
      tradeId: 'explicit.stat_4103953516',
      description: 'Yellow Beasts in your Maps have (12–18)% chance to be replaced with Red Beasts',
      range: [12, 18],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_bestiary_beasts_in_your_maps_conqueror_700': {
      id: 700,
      tradeId: 'explicit.stat_3241030924',
      description: 'Beasts in your Maps have a (15–20)% chance to break free Beasts which break free in your Maps gain Bestial Rage Defeating Beasts grants Hunters Cunning per Bestial Rage on the defeated Beast',
      range: [15, 20],
      contentType: ContentType.BESTIARY,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_beyond_slaying_enemies_in_your_conqueror': {
      id: 701,
      tradeId: 'explicit.stat_3036422124',
      description: 'Slaying Enemies in your Maps has a (12–18)% increased chance to spawn a Beyond Portal',
      range: [12, 18],
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_beyond_gain_demonic_power_on_conqueror': {
      id: 702,
      tradeId: 'explicit.stat_3366450400',
      description: 'Gain Demonic Power on defeating a Beyond Boss in your Maps',
      contentType: ContentType.BEYOND,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_blight_varieties_of_items_contained_conqueror': {
      id: 703,
      tradeId: 'explicit.stat_1730598557',
      description: 'Varieties of Items contained in (3–5) Blight Chests in your Maps are Lucky',
      range: [3, 5],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_blight_blight_chests_in_your_conqueror': {
      id: 704,
      tradeId: 'explicit.stat_278772496',
      description: 'Blight chests in your Maps have a (5–10)% chance to be openable again',
      range: [5, 10],
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_blight_completing_a_blight_encounter_conqueror': {
      id: 705,
      tradeId: 'explicit.stat_3127831894',
      description: 'Completing a Blight Encounter in your Maps grants all Players Blightreach',
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_blight_blight_towers_in_your_conqueror': {
      id: 706,
      tradeId: 'explicit.stat_1421406768',
      description: 'Blight Towers in your Maps can be Salvaged after the Blight Encounter Higher Tier Towers grant better Salvaged Rewards Salvaged Rewards are improved for each different Tower Type built during Encounter',
      contentType: ContentType.BLIGHT,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_breach_breach_bosses_defeated_in_conqueror': {
      id: 707,
      tradeId: 'explicit.stat_988187710',
      description: 'Breach Bosses Defeated in your Maps have (3–5)% chance to drop a Breachstone',
      range: [3, 5],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_conqueror': {
      id: 708,
      tradeId: 'explicit.stat_2224050171',
      description: 'Breaches in your Maps contain (2–3) additional Clasped Hands',
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_breach_breaches_in_your_maps_conqueror_709': {
      id: 709,
      tradeId: 'explicit.stat_1601064200',
      description: 'Breaches in your Maps have (2–3)% chance to contain Xesht–Ula, the Open Hand',
      range: [2, 3],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_breach_breach_boss_clasped_hands_conqueror': {
      id: 710,
      tradeId: 'explicit.stat_3465894962',
      description: 'Breach Boss\' Clasped Hands in your Maps have (3–5)% chance to spawn a Breach Boss when opened',
      range: [3, 5],
      contentType: ContentType.BREACH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_searing_exarch_your_maps_have_1015_conqueror': {
      id: 711,
      tradeId: 'explicit.stat_2523194133',
      description: 'Your Maps have (10–15)% chance to award double progress towards encountering The Searing Exarch',
      range: [10, 15],
      contentType: ContentType.SEARING_EXARCH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_searing_exarch_eldritch_embers_found_in_conqueror': {
      id: 712,
      tradeId: 'explicit.stat_2514681311',
      description: 'Eldritch Embers found in your Maps influenced by The Searing Exarch have (10–15)% chance to be Duplicated',
      range: [10, 15],
      contentType: ContentType.SEARING_EXARCH,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_delirium_delirium_encounters_in_your_conqueror': {
      id: 713,
      tradeId: 'explicit.stat_2312030426',
      description: 'Delirium Encounters in your Maps have (8–12)% chance to generate three additional Reward types',
      range: [8, 12],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_delirium_2030_increased_stack_size_conqueror': {
      id: 714,
      tradeId: 'explicit.stat_2301218725',
      description: '(20–30)% increased Stack size of Simulacrum Splinters found in your Maps',
      range: [20, 30],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_delirium_delirious_unique_monsters_in_conqueror': {
      id: 715,
      tradeId: 'explicit.stat_4142971786',
      description: 'Delirious Unique Monsters in your Maps have a (1–2)% chance to drop an additional Delirium Orb',
      range: [1, 2],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_delirium_delirious_unique_monsters_in_conqueror_716': {
      id: 716,
      tradeId: 'explicit.stat_3312982927',
      description: 'Delirious Unique Monsters in your Maps have a (2–3)% chance to drop an additional Cluster Jewel',
      range: [2, 3],
      contentType: ContentType.DELIRIUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_delve_voltaxic_sulphite_veins_and_conqueror': {
      id: 717,
      tradeId: 'explicit.stat_2503157846',
      description: 'Voltaxic Sulphite Veins and Chests in your Maps are guarded by Sulphite–hoarding Monsters',
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_delve_you_gain_23_to_conqueror': {
      id: 718,
      tradeId: 'explicit.stat_1978899297',
      description: 'You Gain +(2–3)% to all maximum Elemental Resistances per stack of Sulphite Intoxication.',
      range: [2, 3],
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_delve_voltaxic_sulphite_veins_and_conqueror_719': {
      id: 719,
      tradeId: 'explicit.stat_3236481633',
      description: 'Voltaxic Sulphite Veins and Chests found in your Maps contains Doomed Spirits',
      contentType: ContentType.DELVE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_shrines_shrines_in_your_maps_conqueror': {
      id: 720,
      tradeId: 'explicit.stat_2167121354',
      description: 'Shrines in your Maps are guarded by at least one Magic Pack',
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_shrines_shrines_in_your_maps_conqueror_721': {
      id: 721,
      tradeId: 'explicit.stat_1594755360',
      description: 'Shrines in your Maps grant a random additional Shrine Effect',
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_shrines_shrines_in_your_maps_conqueror_722': {
      id: 722,
      tradeId: 'explicit.stat_2831543675',
      description: 'Shrines in your Maps have (8–12)% chance to be a Covetous Shrine',
      range: [8, 12],
      contentType: ContentType.SHRINES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_essence_imprisoned_monsters_in_your_conqueror': {
      id: 723,
      tradeId: 'explicit.stat_2175157402',
      description: 'Imprisoned Monsters in your Maps have at least 1 Essence at the highest possible tier',
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_essence_essences_found_in_your_conqueror': {
      id: 724,
      tradeId: 'explicit.stat_2996332612',
      description: 'Essences found in your Maps have (25–35)% chance to be a tier higher',
      range: [25, 35],
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_essence_using_remnants_of_corruption_conqueror': {
      id: 725,
      tradeId: 'explicit.stat_1019460035',
      description: 'Using Remnants of Corruption on Imprisoned Monsters in your Maps replaces all Essences with one of the Essences on the Imprisoned Monster',
      contentType: ContentType.ESSENCE,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_expedition_80120_increased_explosive_placement_conqueror': {
      id: 726,
      tradeId: 'explicit.stat_1539368271',
      description: '(80–120)% increased Explosive Placement Range in your Maps',
      range: [80, 120],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_expedition_expeditions_in_your_maps_conqueror': {
      id: 727,
      tradeId: 'explicit.stat_3753446846',
      description: 'Expeditions in your Maps have +(1–2) Remnants',
      range: [1, 2],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_expedition_your_maps_contain_2025_conqueror': {
      id: 728,
      tradeId: 'explicit.stat_1640965354',
      description: 'Your Maps contain (20–25)% increased number of Runic Monster Markers',
      range: [20, 25],
      contentType: ContentType.EXPEDITION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_harbinger_currency_shards_dropped_by_conqueror': {
      id: 729,
      tradeId: 'explicit.stat_866347860',
      description: 'Currency Shards dropped by Harbingers in your Maps can drop as Currency Items instead',
      contentType: ContentType.HARBINGER,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_harvest_plants_harvested_in_your_conqueror': {
      id: 730,
      tradeId: 'explicit.stat_2634325281',
      description: 'Plants Harvested in your Maps have (4–8)% chance to spawn duplicated Monsters',
      range: [4, 8],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_harvest_harvested_plants_in_your_conqueror': {
      id: 731,
      tradeId: 'explicit.stat_4128958145',
      description: 'Harvested Plants in your Maps have (10–15)% chance to spawn an additional Monster',
      range: [10, 15],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_harvest_lifeforce_dropped_by_harvest_conqueror': {
      id: 732,
      tradeId: 'explicit.stat_2591612078',
      description: 'Lifeforce dropped by Harvest Monsters in your Maps has (10–15)% chance to be Duplicated',
      range: [10, 15],
      contentType: ContentType.HARVEST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_heist_blueprints_that_drop_in_conqueror': {
      id: 733,
      tradeId: 'explicit.stat_3113439544',
      description: 'Blueprints that drop in your Maps have (10–15)% chance to be fully Revealed',
      range: [10, 15],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_heist_your_maps_that_contain_conqueror': {
      id: 734,
      tradeId: 'explicit.stat_1488908340',
      description: 'Your Maps that contain Smuggler\'s Caches have a (4–6)% chance to contain 6 additional Smuggler\'s Caches',
      range: [4, 6],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_heist_smugglers_caches_in_your_conqueror': {
      id: 735,
      tradeId: 'explicit.stat_3556555275',
      description: 'Smuggler\'s Caches in your Maps have (10–15)% increased chance to contain Blueprints for each Smuggler\'s Cache opened in the Map',
      range: [10, 15],
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_heist_huck_accompanies_you_on_conqueror': {
      id: 736,
      tradeId: 'explicit.stat_4286661423',
      description: 'Huck accompanies you on opening the first Smuggler\'s Cache in each of your Maps',
      contentType: ContentType.HEIST,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_betrayal_immortal_syndicate_members_in_conqueror': {
      id: 737,
      tradeId: 'explicit.stat_574706723',
      description: 'Immortal Syndicate Members in your Maps drop (100–200)% more Items when Bargained with for Items',
      range: [100, 200],
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_betrayal_completing_your_maps_grants_conqueror': {
      id: 738,
      tradeId: 'explicit.stat_424189350',
      description: 'Completing your Maps grants (10–15) Intelligence for a random Immortal Syndicate Safehouse',
      contentType: ContentType.BETRAYAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_lab_labyrinth_trials_in_your_conqueror': {
      id: 739,
      tradeId: 'explicit.stat_340272125',
      description: 'Labyrinth Trials in your Maps have (20–25)% chance to award an Improved Offering to the Goddess',
      range: [20, 25],
      contentType: ContentType.LAB,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_in_your_conqueror': {
      id: 740,
      tradeId: 'explicit.stat_480028751',
      description: 'Legion Encounters in your Maps contain 2 additional Sergeants',
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_legion_legion_encounters_with_a_conqueror': {
      id: 741,
      tradeId: 'explicit.stat_2347014488',
      description: 'Legion Encounters with a General in your Maps have both Generals',
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_legion_05075_chance_for_timeless_conqueror': {
      id: 742,
      tradeId: 'explicit.stat_407036985',
      description: '(0.5–0.75)% chance for Timeless Splinters to drop as Timeless Emblems instead in your Maps',
      range: [0.5, 0.75],
      contentType: ContentType.LEGION,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_encounters_in_your_conqueror': {
      id: 743,
      tradeId: 'explicit.stat_1937345315',
      description: 'Ultimatum Encounters in your Maps grant rewards as though you completed an additional Round',
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_boss_drops_a_conqueror': {
      id: 744,
      tradeId: 'explicit.stat_236047788',
      description: 'Ultimatum Boss drops a full stack of a random Catalyst',
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_ultimatum_ultimatum_rewards_in_your_conqueror': {
      id: 745,
      tradeId: 'explicit.stat_1683239984',
      description: 'Ultimatum Rewards in your Maps have (20–25)% chance to be duplicated',
      range: [20, 25],
      contentType: ContentType.ULTIMATUM,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_ritual_your_maps_with_ritual_conqueror': {
      id: 746,
      tradeId: 'explicit.stat_2302977956',
      description: 'Your Maps with Ritual Altars always have four Ritual Altars',
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_ritual_ritual_altars_in_your_conqueror': {
      id: 747,
      tradeId: 'explicit.stat_120737942',
      description: 'Ritual Altars in your Maps allow rerolling Favours an additional time',
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_ritual_completing_the_final_ritual_conqueror': {
      id: 748,
      tradeId: 'explicit.stat_3008766302',
      description: 'Completing the final Ritual Altar in your Maps has (15–20)% chance to drop a Blood–filled Vessel',
      range: [15, 20],
      contentType: ContentType.RITUAL,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_scarabs_map_device_has_35_conqueror': {
      id: 749,
      tradeId: 'explicit.stat_4140427516',
      description: 'Map Device has (3–5)% chance not to consume Scarabs',
      range: [3, 5],
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_scarabs_scarabs_found_in_your_conqueror': {
      id: 750,
      tradeId: 'explicit.stat_2789471089',
      description: 'Scarabs found in your Maps are more likely to be less common varieties',
      contentType: ContentType.SCARABS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_in_your_maps_conqueror': {
      id: 751,
      tradeId: 'explicit.stat_1564500422',
      description: 'Strongboxes in your Maps are at least Rare',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_in_your_maps_conqueror_752': {
      id: 752,
      tradeId: 'explicit.stat_2681419531',
      description: 'Strongboxes in your Maps are Corrupted',
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_strongboxes_strongboxes_opened_in_your_conqueror': {
      id: 753,
      tradeId: 'explicit.stat_3353484695',
      description: 'Strongboxes opened in your Maps have (5–9)% chance to be openable again',
      range: [5, 9],
      contentType: ContentType.STRONGBOXES,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_synthesis_synthesised_monsters_in_synthesis_conqueror': {
      id: 754,
      tradeId: 'explicit.stat_2049349490',
      description: 'Synthesised Monsters in Synthesis Maps have (20–30)% increased Pack Size',
      range: [20, 30],
      contentType: ContentType.SYNTHESIS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_eater_of_worlds_monster_packs_influenced_by_conqueror': {
      id: 755,
      tradeId: 'explicit.stat_4185631652',
      description: 'Monster Packs Influenced by The Eater of Worlds in your Maps have (25–35)% increased Pack Size',
      range: [25, 35],
      contentType: ContentType.EATER_OF_WORLDS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_tormented_spirits_tormented_spirits_in_your_conqueror': {
      id: 756,
      tradeId: 'explicit.stat_564845047',
      description: 'Tormented Spirits in your Maps are more likely to be less common varieties',
      contentType: ContentType.TORMENTED_SPIRITS,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    'suffix_maven_defeating_a_map_boss_conqueror': {
      id: 757,
      tradeId: 'explicit.stat_3089299676',
      description: 'Defeating a Map Boss while Witnessed by The Maven has (10–15)% chance to count as also Witnessing an additional random Map Boss',
      range: [10, 15],
      contentType: ContentType.MAVEN,
      idolSizes: [IdolSize.CONQUEROR],
      type: 'suffix'
    },
    // Arbitrary Tenets
  'prefix_arbitrary_tenets_1': {
    id: 1001,
      tradeId: 'explicit.stat_1276541261',
    description: 'Favours at Ritual Altars in your Maps randomly cost between 90% less and 80% more',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Black Thumb
  'prefix_black_thumb_1': {
    id: 1002,
      tradeId: 'explicit.stat_328145899',
    description: 'Your Maps have no chance to contain the Sacred Grove',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_black_thumb_2': {
    id: 1003,
      tradeId: 'explicit.stat_388787643',
    description: 'Scarabs found in your Maps cannot be Harvest Scarabs',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_black_thumb_3': {
    id: 1004,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Bold Undertakings
  'prefix_bold_undertakings_1': {
    id: 1005,
      tradeId: 'explicit.stat_1944897696',
    description: 'Fortune Favours the Brave applies an additional random Option',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_bold_undertakings_2': {
    id: 1006,
      tradeId: 'explicit.stat_1944897696',
    description: '100% more cost of the Fortune Favours the Brave Map Crafting Option',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Cassia's Pride
  'prefix_cassias_pride_1': {
    id: 1007,
      tradeId: 'explicit.stat_2460639269',
    description: 'Blight Monsters in your Maps take (75–65)% less Damage from Players and their Minions',
    range: [65, 75],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_cassias_pride_2': {
    id: 1008,
      tradeId: 'explicit.stat_3738423246',
    description: 'Blight Towers and their Minions in your Maps deal (300–400)% more Damage',
    range: [300, 400],
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Crop Rotation
  'prefix_crop_rotation_1': {
    id: 1009,
      tradeId: 'explicit.stat_2765997141',
    description: 'Harvest Crops in your Maps contain only Tier 1 Plants',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_crop_rotation_2': {
    id: 1010,
      tradeId: 'explicit.stat_2765997141',
    description: 'Harvesting Crops in your Maps has a chance to upgrade the Tier of Plants of different colours',
    contentType: ContentType.HARVEST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Crystallised Power
  'prefix_crystallised_power_1': {
    id: 1011,
      tradeId: 'explicit.stat_2623157736',
    description: 'A Map Boss is granted a random Essence Modifier from any Imprisoned Monsters slain in your Maps',
    contentType: ContentType.ESSENCE,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Dance of Destruction
  'prefix_dance_of_destruction_1': {
    id: 1012,
      tradeId: 'explicit.stat_3516276449',
    description: 'Monsters in your Maps deal (20–25)% more Damage',
    range: [20, 25],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_dance_of_destruction_2': {
    id: 1013,
    tradeId: 'explicit.stat_4190580879',
    description: 'Monsters in your Maps have (30–25)% less Life',
    range: [25, 30],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Destructive Play
  'prefix_destructive_play_1': {
    id: 1014,
    tradeId: 'explicit.stat_2960155368',
    description: 'The Maven casts Up the Stakes, summoning 1 to 3 additional Atlas Bosses when Witnessing Map Bosses',
    contentType: ContentType.MAVEN,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_destructive_play_2': {
    id: 1015,
      tradeId: 'explicit.stat_2960155368',
    description: 'The number of additional Bosses summoned is higher if there are fewer monsters remaining in the Map',
    contentType: ContentType.MAVEN,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_destructive_play_3': {
    id: 1016,
      tradeId: 'explicit.stat_2960155368',
    description: 'Modifiers to the Final Map Boss in each Map also apply to these summoned Bosses',
    contentType: ContentType.MAVEN,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Dimensional Barrier
  'prefix_dimensional_barrier_1': {
    id: 1017,
      tradeId: 'explicit.stat_1562449600',
    description: 'Your Maps have no chance to contain Breaches',
    contentType: ContentType.BREACH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_dimensional_barrier_2': {
    id: 1018,
      tradeId: 'explicit.stat_1089629910',
    description: 'Scarabs found in your Maps cannot be Breach Scarabs',
    contentType: ContentType.BREACH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_dimensional_barrier_3': {
    id: 1019,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.BREACH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Eldritch Gaze
  'prefix_eldritch_gaze_1': {
    id: 1020,
      tradeId: 'explicit.stat_1488839433',
    description: 'Eldritch Altars Influenced by The Eater of Worlds have an additional Downside',
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_eldritch_gaze_2': {
    id: 1021,
      tradeId: 'explicit.stat_3619368685',
    description: 'Eldritch Altars Influenced by The Eater of Worlds have (50–60)% increased Effect of Upsides',
    range: [50, 60],
    contentType: ContentType.EATER_OF_WORLDS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Endless Tide
  'prefix_endless_tide_1': {
    id: 1022,
      tradeId: 'explicit.stat_1280481887',
    description: 'Beyond Portals in your Maps cannot spawn Unique Bosses',
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_endless_tide_2': {
    id: 1023,
      tradeId: 'explicit.stat_3009539307',
    description: 'Beyond Portals in your Maps have (50–40)% less Merging Radius',
    range: [40, 50],
    contentType: ContentType.BEYOND,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Extreme Archaeology
  'prefix_extreme_archaeology_1': {
    id: 1024,
      tradeId: 'explicit.stat_353291915',
    description: 'Number of Explosives is one',
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_extreme_archaeology_2': {
    id: 1025,
      tradeId: 'explicit.stat_3289828378',
    description: '(200–250)% increased Explosive Radius in your Maps',
    range: [200, 250],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_extreme_archaeology_3': {
    id: 1026,
      tradeId: 'explicit.stat_2684644644',
    description: 'Expedition Monsters in your Maps spawn with an additional (10–15)% of Life missing',
    range: [10, 15],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_extreme_archaeology_4': {
    id: 1027,
      tradeId: 'explicit.stat_1539368271',
    description: '(100–150)% increased Explosive Placement Range in your Maps',
    range: [100, 150],
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Fungal Remission
  'prefix_fungal_remission_1': {
    id: 1028,
      tradeId: 'explicit.stat_1981776737',
    description: 'Your Maps have no chance to contain Blight Encounters',
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_fungal_remission_2': {
    id: 1029,
      tradeId: 'explicit.stat_785938790',
    description: 'Scarabs found in your Maps cannot be Blight Scarabs',
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_fungal_remission_3': {
    id: 1030,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.BLIGHT,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Gruelling Gauntlet
  'prefix_gruelling_gauntlet_1': {
    id: 1031,
      tradeId: 'explicit.stat_3283585444',
    description: 'Ultimatum Encounters in your Maps last up to 13 Rounds',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_gruelling_gauntlet_2': {
    id: 1032,
      tradeId: 'explicit.stat_3845167239',
    description: 'Players cannot choose which Ultimatum Modifier is applied each Round',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_gruelling_gauntlet_3': {
    id: 1033,
      tradeId: 'explicit.stat_2694161522',
    description: 'Cannot have a Boss in the final Round',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Immutable Dogma
  'prefix_immutable_dogma_1': {
    id: 1034,
      tradeId: 'explicit.stat_164133604',
    description: 'Cannot Reroll Favours at Ritual Altars in your Maps',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_immutable_dogma_2': {
    id: 1035,
      tradeId: 'explicit.stat_2590915311',
    description: 'Monsters Sacrificed at Ritual Altars in your Maps grant (100–150)% more Tribute',
    range: [100, 150],
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Loved by the Sun
  'prefix_loved_by_the_sun_1': {
    id: 1036,
      tradeId: 'explicit.stat_2399560930',
    description: 'Your Maps have no chance to contain Abysses',
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_loved_by_the_sun_2': {
    id: 1037,
      tradeId: 'explicit.stat_1978710645',
    description: 'Scarabs found in your Maps cannot be Abyss Scarabs',
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_loved_by_the_sun_3': {
    id: 1038,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.ABYSS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Lucid Dreams
  'prefix_lucid_dreams_1': {
    id: 1039,
      tradeId: 'explicit.stat_1516986886',
    description: 'Vaal Side Areas in your Maps are no longer Corrupted',
    contentType: ContentType.VAAL_SIDE_AREAS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Meticulous Appraiser
  'prefix_meticulous_appraiser_1': {
    id: 1040,
      tradeId: 'explicit.stat_3399892496',
    description: 'Modifiers to Quantity of Items found in your Maps instead apply to Rarity of Items found in your Maps at 300% of their value',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Ominous Silence
  'prefix_ominous_silence_1': {
    id: 1041,
      tradeId: 'explicit.stat_2400312255',
    description: 'Your Maps have no chance to contain Mirrors of Delirium',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_ominous_silence_2': {
    id: 1042,
      tradeId: 'explicit.stat_278421201',
    description: 'Scarabs found in your Maps cannot be Delirium Scarabs',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_ominous_silence_3': {
    id: 1043,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Perceived Greatness
  'prefix_perceived_greatness_1': {
    id: 1044,
      tradeId: 'explicit.stat_3428124128',
    description: 'Delirious Monsters Killed in your Maps provide (30–20)% reduced Reward Progress',
    range: [20, 30],
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_perceived_greatness_2': {
    id: 1045,
      tradeId: 'explicit.stat_3387171641',
    description: 'Delirium Reward Types in your Maps gain +1 to count on Map Completion',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Ruinous Wager
  'prefix_ruinous_wager_1': {
    id: 1046,
      tradeId: 'explicit.stat_3645622851',
    description: 'Ultimatum Monsters in your Maps apply Ruin with their special abilities',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_ruinous_wager_2': {
    id: 1047,
      tradeId: 'explicit.stat_3645622851',
    description: 'Fail on reaching 7 Ruin',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_ruinous_wager_3': {
    id: 1048,
      tradeId: 'explicit.stat_3683980805',
    description: 'Ultimatum Monsters and Modifiers in your Maps deal (60–50)% less Damage',
    range: [50, 60],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Sealed Domain
  'prefix_sealed_domain_1': {
    id: 1049,
      tradeId: 'explicit.stat_1132162798',
    description: 'Your Maps have no chance to contain Legion Encounters',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_sealed_domain_2': {
    id: 1050,
      tradeId: 'explicit.stat_3777973541',
    description: 'Scarabs found in your Maps cannot be Legion Scarabs',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_sealed_domain_3': {
    id: 1051,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Secular Focus
  'prefix_secular_focus_1': {
    id: 1052,
      tradeId: 'explicit.stat_847340197',
    description: 'Your Maps have no chance to contain Ritual Altars',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_secular_focus_2': {
    id: 1053,
      tradeId: 'explicit.stat_1693489030',
    description: 'Scarabs found in your Maps cannot be Ritual Scarabs',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_secular_focus_3': {
    id: 1054,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.RITUAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Servant of Order
  'prefix_servant_of_order_1': {
    id: 1055,
      tradeId: 'explicit.stat_3819443367',
    description: 'Your Maps have no chance to contain Ultimatum Encounters',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_servant_of_order_2': {
    id: 1056,
      tradeId: 'explicit.stat_264552782',
    description: 'Scarabs found in your Maps cannot be Ultimatum Scarabs',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_servant_of_order_3': {
    id: 1057,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Shadow Shaping
  'prefix_shadow_shaping_1': {
    id: 1058,
      tradeId: 'explicit.stat_441900529',
    description: 'Maps found cannot be your Favoured Maps',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_shadow_shaping_2': {
    id: 1059,
      tradeId: 'explicit.stat_1363247141',
    description: 'Maps found in your Maps have +1% chance to have a special Implicit Modifier for each different Map you have Favoured',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Singular Focus
  'prefix_singular_focus_1': {
    id: 1060,
      tradeId: 'explicit.stat_3527275979',
    description: 'Maps found have (200–220)% more chance to be Favoured Maps',
    range: [200, 220],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_singular_focus_2': {
    id: 1061,
      tradeId: 'explicit.stat_3764294022',
    description: 'Non–Favoured Maps found in your Maps drop as Basic Currency Items instead',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Smash and Grab
  'prefix_smash_and_grab_1': {
    id: 1062,
      tradeId: 'explicit.stat_95850091',
    description: 'Each Legion in your Maps contains an additional War Hoard',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_smash_and_grab_2': {
    id: 1063,
      tradeId: 'explicit.stat_1088328219',
    description: 'Legion Chests in your Maps contain an additional Random Reward',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_smash_and_grab_3': {
    id: 1064,
      tradeId: 'explicit.stat_699122342',
    description: 'Legion Encounters in your Maps have (80–60)% reduced Duration',
    range: [60, 80],
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Speaker of the Dead
  'prefix_speaker_of_the_dead_1': {
    id: 1065,
      tradeId: 'explicit.stat_3249943883',
    description: 'Tormented Spirits in your Maps can Possess Players for 20 seconds',
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_speaker_of_the_dead_2': {
    id: 1066,
      tradeId: 'explicit.stat_3249943883',
    description: 'Tormented Spirits in your Maps cannot Possess Monsters',
    contentType: ContentType.TORMENTED_SPIRITS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Straight and Narrow
  'prefix_straight_and_narrow_1': {
    id: 1067,
      tradeId: 'explicit.stat_3178985579',
    description: 'Your Maps have no chance to contain Smuggler\'s Caches',
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_straight_and_narrow_2': {
    id: 1068,
      tradeId: 'explicit.stat_1379148633',
    description: 'Rogue\'s Markers, Contracts and Blueprints cannot be found in Your Maps',
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_straight_and_narrow_3': {
    id: 1069,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.HEIST,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Thorough Exploration
  'prefix_thorough_exploration_1': {
    id: 1070,
      tradeId: 'explicit.stat_199329214',
    description: 'If there are fewer than 50 monsters remaining in your Maps, Final Map Bosses are Empowered by Wildwood Wisps',
    contentType: ContentType.MISC,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Timeless Conflict
  'prefix_timeless_conflict_1': {
    id: 1071,
      tradeId: 'explicit.stat_222333372',
    description: 'Legion Encounters in your Maps have no Timer',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_timeless_conflict_2': {
    id: 1072,
      tradeId: 'explicit.stat_222333372',
    description: 'Breaking out Monsters and Chests that are in stasis progressively causes a Schism',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_timeless_conflict_3': {
    id: 1073,
      tradeId: 'explicit.stat_222333372',
    description: 'Legion Encounters in your Maps begin once the Schism has occurred',
    contentType: ContentType.LEGION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Trade Embargo
  'prefix_trade_embargo_1': {
    id: 1074,
      tradeId: 'explicit.stat_2978599106',
    description: 'Your Maps have no chance to contain Expedition Encounters',
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_trade_embargo_2': {
    id: 1075,
      tradeId: 'explicit.stat_3965835074',
    description: 'Scarabs found in your Maps cannot be Expedition Scarabs',
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_trade_embargo_3': {
    id: 1076,
      tradeId: 'explicit.stat_344979199',
    description: 'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives',
    contentType: ContentType.EXPEDITION,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Twist of Fate
  'prefix_twist_of_fate_1': {
    id: 1077,
      tradeId: 'explicit.stat_3936990754',
    description: 'Your Corrupted Rare Maps and any Map Crafting options applying to them are modified unpredictably when opened',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twist_of_fate_2': {
    id: 1078,
      tradeId: 'explicit.stat_812317919',
    description: 'Maps modified in this way have 1–3 additional random Map Modifiers',
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Twisted Wish
  'prefix_twisted_wish_fixed_1': {
    id: 1079,
      tradeId: 'explicit.stat_1901628087',
    description: 'Ultimatum Modifiers in your Maps start a Tier higher if possible',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_fixed_2': {
    id: 1080,
      tradeId: 'explicit.stat_1602736646',
    description: 'Ultimatum Encounters in your Maps get 3% reduced Radius each Round',
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_1': {
    id: 1081,
      tradeId: 'explicit.stat_3093967539',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Abyssal Items',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_2': {
    id: 1082,
      tradeId: 'explicit.stat_1763481236',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Blight Oils',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_3': {
    id: 1083,
      tradeId: 'explicit.stat_502838809',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Breach Items',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_4': {
    id: 1084,
      tradeId: 'explicit.stat_4234425443',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Catalysts',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_5': {
    id: 1085,
      tradeId: 'explicit.stat_1528872781',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Corrupted Rare Items',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_6': {
    id: 1086,
      tradeId: 'explicit.stat_1656757869',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Currency Items',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_7': {
    id: 1087,
      tradeId: 'explicit.stat_3324186704',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Delirium Items',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_8': {
    id: 1088,
      tradeId: 'explicit.stat_297961897',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Divination Cards',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_9': {
    id: 1089,
      tradeId: 'explicit.stat_3860246335',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Essences',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_10': {
    id: 1090,
      tradeId: 'explicit.stat_469837536',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Fossils',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_11': {
    id: 1091,
      tradeId: 'explicit.stat_3116664709',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Map Fragments',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_12': {
    id: 1092,
      tradeId: 'explicit.stat_2091246228',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Gems',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_13': {
    id: 1093,
      tradeId: 'explicit.stat_1322064377',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Heist Items',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_14': {
    id: 1094,
      tradeId: 'explicit.stat_294140055',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Inscribed Ultimatums',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_15': {
    id: 1095,
      tradeId: 'explicit.stat_3962675867',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Legion Items',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_16': {
    id: 1096,
      tradeId: 'explicit.stat_3261121444',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Maps',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_twisted_wish_variable_17': {
    id: 1097,
      tradeId: 'explicit.stat_1280423224',
    description: 'Ultimatum Rewards in your Maps have (95–80)% reduced chance to be Unique Items',
    range: [80, 95],
    contentType: ContentType.ULTIMATUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Unending Nightmare
  'prefix_unending_nightmare_1': {
    id: 1098,
      tradeId: 'explicit.stat_4222365107',
    description: 'Delirium Fog in your Maps never dissipates',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_unending_nightmare_2': {
    id: 1099,
      tradeId: 'explicit.stat_4222365107',
    description: 'Delirium in your Maps has doubled difficulty scaling with distance from the mirror',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_unending_nightmare_3': {
    id: 1100,
      tradeId: 'explicit.stat_4222365107',
    description: 'Simulacrum Splinters cannot be found in your Maps',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_unending_nightmare_4': {
    id: 1101,
      tradeId: 'explicit.stat_4222365107',
    description: 'Delirium Orbs cannot be found in your Maps',
    contentType: ContentType.DELIRIUM,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Well Supplied
  'prefix_well_supplied_1': {
    id: 1102,
      tradeId: 'explicit.stat_1682417271',
    description: '(30–50)% increased Intelligence gained from Immortal Syndicate targets encountered in your Maps',
    range: [30, 50],
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_well_supplied_2': {
    id: 1103,
      tradeId: 'explicit.stat_623132242',
    description: 'Syndicate Members Obtain an additional Equipment Item when appearing in your Maps',
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_well_supplied_3': {
    id: 1104,
      tradeId: 'explicit.stat_1856204587',
    description: 'Immortal Syndicate Leaders in your Maps drop an additional Veiled Item',
    contentType: ContentType.BETRAYAL,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  // Wellspring of Creation
  'prefix_wellspring_of_creation_2': {
    id: 1105,
      tradeId: 'explicit.stat_2937898686',
    description: 'Monsters in your Maps deal (30–25)% less Damage',
    range: [25, 30],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_wellspring_of_creation_1': {
    id: 1106,
      tradeId: 'explicit.stat_2804300445',
    description: 'Monsters in your Maps have (40–50)% more Life',
    range: [40, 50],
    contentType: ContentType.MAPS,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  
  
  // Wrath of the Cosmos
  'prefix_wrath_of_the_cosmos_1': {
    id: 1107,
      tradeId: 'explicit.stat_1804970439',
    description: 'Eldritch Altars Influenced by The Searing Exarch which have an additional Upside have (80–100)% increased Effect of Downsides',
    range: [80, 100],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  'prefix_wrath_of_the_cosmos_2': {
    id: 1108,
      tradeId: 'explicit.stat_2348590020',
    description: 'Eldritch Altars Influenced by The Searing Exarch have (50–60)% chance to have an additional Upside',
    range: [50, 60],
    contentType: ContentType.SEARING_EXARCH,
    idolSizes: [IdolSize.UNIQUE],
    type: 'prefix'
  },
  };

  // Build the database with indexes for faster lookups
  const buildModDatabase = (): ModDatabase => {
    const db: ModDatabase = {
      mods: {},
      byContentType: {} as Record<ContentType, number[]>,
      byIdolSize: {} as Record<IdolSize, {
        prefixes: number[],
        suffixes: number[]
      }>
    };
  
    // Initialize empty arrays for each contentType
    Object.values(ContentType).forEach(contentType => {
      db.byContentType[contentType] = [];
    });
  
    // Initialize empty arrays for each idol type
    Object.values(IdolSize).forEach(idolSize => {
      db.byIdolSize[idolSize] = {
        prefixes: [],
        suffixes: []
      };
    });
  
    // Process prefixes
    Object.values(mods).forEach(mod => {
      // Add to main collection
      db.mods[mod.id] = mod;
      
      // Add to contentType index
      db.byContentType[mod.contentType].push(mod.id);
      
      // Add to idol size indexes
      mod.idolSizes.forEach(idolSize => {
        if (mod.type === 'prefix') {
          db.byIdolSize[idolSize].prefixes.push(mod.id);
        } else {
          db.byIdolSize[idolSize].suffixes.push(mod.id);
        }
      });
    });
    
    return db;
  };
  
  // Export the full database
  export const modDatabase = buildModDatabase();
  
  // Utility function to get mods for a specific idol type
  export const getModsForIdolSize = (idolSize: IdolSize, type?: 'prefixes' | 'suffixes'): Mod[] => {
    // Check if type is provided and return the corresponding mods
    const modIds = type ? modDatabase.byIdolSize[idolSize][type] : 
                          [...modDatabase.byIdolSize[idolSize].prefixes, ...modDatabase.byIdolSize[idolSize].suffixes];
    return modIds
      .map(id => modDatabase.mods[id]);
  };
  
  // Utility function to get mods by contentType
  export const getModsByContentType = (contentType: ContentType, type?: 'prefix' | 'suffix'): (Mod)[] => {
    const modIds = type ? modDatabase.byContentType[contentType].filter(id => modDatabase.mods[id].type === type) : 
                          modDatabase.byContentType[contentType] || [];
    return modIds
      .map(id => modDatabase.mods[id]);
  };
  
  // Format the description with actual values instead of ranges
  export const formatModDescription = (mod: Mod, value: number): string => {
    return mod.description.replace(/(\+?\()(\d+(?:\.\d+)?)–(\d+(?:\.\d+)?)(\)%)/g, (prefix) => {
      // Keep the + if it exists in the prefix
      const plusSign = prefix.includes('+') ? '+' : '';
      return `${plusSign}${value}%`;
    });
  };